import { CSSProperties, ReactNode, useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./BundlePreviewWrapper.module.css";
import {
    AvailableBXGYTemplates,
    AvailableFBTTemplates,
    AvailableStandardTemplates,
    BundleTypes,
    checkBundleStockAvailability,
    findSwatchEntryForOption,
    findSwatchEntryForValue,
    getFinalPrice,
    mergeById,
    trackAbVisitorEvent,
    updateBundleStats,
} from "../constants";
import {
    BxgyConfigInterface,
    FBTConfigInterface,
    MixMatchConfigInterface,
    PlaceholderConfigInterface,
    ProductAddonsConfigInterface,
    ProductAddonsPopupConfigInterface,
    ProductObj,
    StandardConfigInterface,
    VariantsObj,
    VolumeConfigInterface,
} from "../Types";
import { getModifiedImageUrl, hexToHsba } from "../../utilities";
import config from "../../../config";
import { IoCloseOutline } from "react-icons/io5";
import BundlePreviewFooter from "./BundlePreviewFooter";
import useIsMobile from "../../../hooks/useIsMobile";
import Tooltip from "../../../components/Tooltip/Tooltip";
import {
    isDesktopUIForMixMatch,
    isThirdPartyCheckout,
    addBundleToCart,
    getProductAsBundleVariantId,
    handleBundleCheckout,
} from "../RenderOnStore/utilities";
import { Icon } from "@shopify/polaris";
import { ImageIcon } from "@shopify/polaris-icons";
import { GoChevronDown, GoChevronRight } from "react-icons/go";
import { InspectorEditableBlock } from "../CommonFields/InspectorEditableBlock";
import { MetalBirdBundlePreviewStyles } from "../../customStyles";
import {
    ADD_TO_CART_CLICKED,
    MAYUR_TEST_STORE,
    SPORTS_TOP_URL,
    IS_METAL_BIRD_SHOP,
    ADITYA_STORE,
    executeScopedJS,
    injectScopedCSS,
    isLilSweetTreatStore,
} from "../../constants";
import cartWatcher from "../../CartWatcherClass";
import CheckoutModal from "../BundleBuilder/BundleBuilderBundle/CheckoutModal";
import { lightenHexColor } from "../../../utilities/parsers";

// const filterAvailableOptions = (variants: any[], options: any[]) => {
//     // Iterate through each option and check if it's available in any of the variants
//     return options.map((option, index) => {
//         const availableValues = option.values.filter((value: string) => {
//             // Check if this value is present in any variant's selectedOptions at the given index
//             return variants.some(
//                 (variant) => variant.selectedOptions[index].value === value,
//             );
//         });

//         return {
//             ...option,
//             values: availableValues, // Only keep the available values
//         };
//     });
// }

function filterOptionsByVariants(variants: any[], options: any[]) {
    const usedValues = new Set(variants.flatMap((v) => v.selectedOptions?.map((o: any) => o.value) || []));

    return options.map((option) => ({
        ...option,
        values: option.values.filter((v: any) => usedValues.has(v)),
    }));
}

export const SubscriptionSelector = ({
    product,
    selectedVariants,
    setSelectedVariants,
}: {
    product: ProductObj;
    selectedVariants: any;
    setSelectedVariants: any;
}) => {
    const handleSubscriptionChange = (e: any) => {
        if (product.isSubscribed) {
            const curSub = product.subscriptions && product.subscriptions.find((sub: any) => sub.id == e.target.value);

            setSelectedVariants((prev: any) => {
                const updatedPlan = prev.map((v: any) => {
                    return {
                        ...v,
                        selling_plan: curSub?.id,
                        price: getFinalPrice(curSub?.discountType, curSub?.discountValue, v.copyPrice),
                    };
                });
                return updatedPlan;
            });
        } else {
            setSelectedVariants((prev: any) => {
                const updatedPlan = prev.map((v: any) => {
                    return {
                        ...v,
                        selling_plan: "",
                    };
                });
                return updatedPlan;
            });
        }
    };

    useEffect(() => {
        if (product.isSubscribed) {
            const curPlan = product.selectedVariants[0]?.selling_plan;
            const curSub = product?.subscriptions?.find((ss) => ss.id == curPlan);

            setSelectedVariants((prev: any) => {
                const updatedPlan = prev.map((v: any) => {
                    return {
                        ...v,
                        price: curSub ? getFinalPrice(curSub.discountType, curSub.discountValue, v.price) : v.price,
                    };
                });
                return updatedPlan;
            });
        }
    }, [product.isSubscribed, product.oneTimePurchase]);

    return (
        <div className={styles.optionsOuterContainer}>
            <div
                style={{
                    // maxWidth: "90%",
                    position: "relative",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%",
                }}
            >
                <span style={{ whiteSpace: "nowrap" }}>Deliver Every</span>
                <select
                    className={styles.select}
                    name={"product_subscriptions"}
                    // id={selectedVariants[0].id}
                    onChange={(e) => handleSubscriptionChange(e)}
                    defaultValue={selectedVariants[0]?.selling_plan || ""}
                >
                    {product.subscriptions &&
                        product.subscriptions
                            .filter((ps: any) => ps.checked == true)
                            .map((plan: any) => (
                                <option className={styles.option} key={plan.id} value={plan.id}>
                                    {plan.name}
                                </option>
                            ))}
                </select>

                {product.oneTimePurchase && (
                    <span
                        style={{
                            border: "1px solid #d7d7d7",
                            padding: "1px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            maxWidth: "20px",
                            maxHeight: "20px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        onClick={() => {
                            product.isSubscribed = false;
                            setSelectedVariants((prev: any) => {
                                const updatedPlan = prev.map((v: any) => {
                                    return {
                                        ...v,
                                        selling_plan: "",
                                        price: v.copyPrice,
                                    };
                                });
                                return updatedPlan;
                            });
                        }}
                    >
                        <IoCloseOutline size={14} />
                    </span>
                )}
            </div>
        </div>
    );
};

export const PoweredByKefiBranding = ({ bundleConfig, _style = {} }: { bundleConfig: any; _style?: CSSProperties }) => {
    typeof bundleConfig;
    typeof _style;
    return <></>;
};

export const Swatches = ({
    variants = [],
    selected,
    handleChange = () => {},
    productCardIndex,
    options,
    standAlone,
    bundlesDesign,
}: {
    variants: any[];
    selected: any[];
    handleChange: any;
    productCardIndex: number;
    options: any[];
    standAlone: boolean;
    bundlesDesign: any;
}) => {
    options = filterOptionsByVariants(variants, options);

    function notExistVariants(options: any) {
        const result: any = [];
        // fxn to create combinations recursively
        function combine(arr: any, index: any, current: any) {
            if (index === arr.length) {
                result.push(current.join(OPTION_SEPARATOR));
                return;
            }

            for (let i = 0; i < arr[index].values.length; i++) {
                combine(arr, index + 1, [...current, arr[index].values[i]]);
            }
        }

        combine(options, 0, []);

        const variantsAv = variants.map((v) => v.selectedOptions.map((o: any) => o.value).join(OPTION_SEPARATOR));
        const outOfStockVaraints = variants
            .filter((v) => v.availableForSale == false)
            .map((v) => v.selectedOptions.map((o: any) => o.value).join(OPTION_SEPARATOR));

        const missingVariants = result.filter((item: string) => !variantsAv.includes(item));

        return [...missingVariants, ...outOfStockVaraints];
    }

    const unavailable_combinations = notExistVariants(options);
    console._log("UNAVAILABLE COMBINATIONS: ", unavailable_combinations);

    const handleSwatchClick = (optionValue: string, optionName: string) => {
        const currentSelectedVariant = selected[productCardIndex];
        const updatedSelectedOptions = [...currentSelectedVariant.selectedOptions];

        const optionIndex = updatedSelectedOptions.findIndex((option) => option.name === optionName);

        if (optionIndex !== -1) {
            updatedSelectedOptions[optionIndex] = { ...updatedSelectedOptions[optionIndex], value: optionValue };
        }

        const selectedOptionsArray = updatedSelectedOptions.map((option) => option.value);
        // console._log({ selectedOptionsArray });

        const matchingVariant = findSelectedVariant(selectedOptionsArray);

        if (matchingVariant) {
            const updatedSelected = [...selected];
            updatedSelected[productCardIndex] = {
                ...matchingVariant,
                copyPrice: matchingVariant.price,
            };

            handleChange(updatedSelected);
        } else {
            console._log("Matching varint not found, means it doesnt exist.");
        }
    };

    const isSelected = (optionName: string, value: string) => {
        const selectedVariant = selected[productCardIndex];
        if (selectedVariant) {
            return selectedVariant.selectedOptions.some(
                (option: any) => option.name === optionName && option.value === value,
            );
        }
        return false;
    };

    const findSelectedVariant = (selectedOptionsArray: string[]) => {
        for (const variant of variants) {
            const hasAllSelectedOptions = selectedOptionsArray.every(
                (selectedValue, i) => variant.selectedOptions[i].value === selectedValue,
            );
            if (hasAllSelectedOptions) {
                return {
                    ...variant,
                    copyPrice: variant.price,
                };
            }
        }
        return null;
    };

    const isCombinationUnavailable = (combination: string) => {
        return unavailable_combinations.includes(combination);
    };

    const generateCurrentCombination = () => {
        const selectedOptions = selected[productCardIndex]?.selectedOptions;
        return selectedOptions?.map((option: any) => option.value).join(OPTION_SEPARATOR) || "";
    };

    const userShopname = standAlone ? window.kefi_bundles.shop : shopify.config.shop;

    const renderSwatches = (option: any) => {
        return (
            <div
                key={option.id}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: "2px",
                }}
            >
                <label
                    className={styles.selectLabel}
                    style={{
                        color: bundlesDesign?.variant_selector_text_color,
                        fontSize: bundlesDesign?.variant_selector_text_size,
                        fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                        fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                        fontFamily:
                            bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                ? "inherit"
                                : bundlesDesign?.bundle_widget_font_family,
                        wordBreak: "break-word",
                    }}
                >
                    {option.name}
                </label>
                <div
                    style={{
                        display: "flex",
                        gap: "5px",
                        flexWrap: "wrap",
                    }}
                >
                    {option.values.map((value: string, idx: number) => {
                        const isOptionSelected = isSelected(option.name, value);

                        const currentCombination = `${generateCurrentCombination()}`;
                        const curCombArr = currentCombination.split(OPTION_SEPARATOR);

                        // // Check if the current combination exists in the unavailable combinations
                        // const isUnavailable = isCombinationUnavailable(newComb.join(OPTION_SEPARATOR));

                        // thse are the dynamically created combinations for this swatch
                        const newComb = [...curCombArr];
                        const optionIndex = options.findIndex((opt) => opt.name === option.name);
                        newComb[optionIndex] = value;

                        const newCombStr = newComb.join(OPTION_SEPARATOR);
                        const isUnavailable = isCombinationUnavailable(newCombStr);

                        return options.length > 1 ? (
                            <button
                                key={value}
                                className={styles.swatch}
                                onClick={() => handleSwatchClick(value, option.name)}
                                disabled={isUnavailable}
                                title={isUnavailable ? "Unavailable" : ""}
                                style={{
                                    padding: "4px 6px",
                                    borderRadius: "6px",
                                    cursor: isUnavailable ? "not-allowed" : "pointer",
                                    backgroundColor: isOptionSelected ? "#2e2a39" : "#ffffff",
                                    color: isUnavailable
                                        ? "#a9a9a9"
                                        : isOptionSelected
                                          ? "#ffffff"
                                          : bundlesDesign?.variant_selector_text_color || "#000000",
                                    textDecoration: isUnavailable ? "line-through" : "none",
                                    aspectRatio: "1/1",
                                    border: "1px solid gray",
                                    fontSize: "12px",
                                    minWidth: 30,
                                    textTransform: "capitalize",
                                }}
                            >
                                {value}
                            </button>
                        ) : (
                            <Tooltip text={value}>
                                <div
                                    style={{
                                        position: "relative",
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        border: isOptionSelected ? "2px solid gray" : "2px solid transparent",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: isUnavailable ? "not-allowed" : "pointer",
                                        lineHeight: "normal",
                                    }}
                                >
                                    <img
                                        src={
                                            userShopname === "typsy-beauty.myshopify.com"
                                                ? getModifiedImageUrl(variants[idx]?.metafield?.value)
                                                : variants[idx]?.image?.originalSrc
                                        }
                                        alt={value}
                                        onClick={() => handleSwatchClick(value, option.name)}
                                        style={{
                                            width: "94%",
                                            height: "94%",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            pointerEvents: isUnavailable ? "none" : "auto",
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                        }}
                                    />

                                    {isUnavailable && (
                                        <span className={styles.customUnavailableOverlay} title="Unavailable" />
                                    )}

                                    {isOptionSelected && (
                                        <img
                                            src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_5.png?v=1722574411"
                                            alt="Selected"
                                            className={styles.customSelectedIcon}
                                        />
                                    )}
                                </div>
                            </Tooltip>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div className={styles.optionsOuterContainer}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                }}
            >
                {options.map((option) => renderSwatches(option))}
            </div>
        </div>
    );
};

const OPTION_SEPARATOR = "|kefi|";
export const CustomSwatches = ({
    variants = [],
    selected,
    handleChange = () => {},
    productCardIndex,
    options,
    metafield,
    bundlesDesign,
    bundleConfig,
    isCart = false,
    upsellDesign = {},
    // maxWidth = "",
    standAlone = false,
    hideLabel = false,
    hideSerialNumber = false,
}: {
    variants: any[];
    selected: any[];
    handleChange: any;
    productCardIndex: number;
    options: any[];
    standAlone: boolean;
    bundlesDesign: any;
    bundleConfig: any;
    metafield?: any;
    isCart?: boolean;
    upsellDesign?: any;
    maxWidth?: string | number;
    hideLabel?: boolean;
    hideSerialNumber?: boolean;
}) => {
    // console._log({ options });
    options = filterOptionsByVariants(variants, options);

    const variantMap = useMemo(() => {
        const map = new Map();

        variants.forEach((variant) => {
            variant.selectedOptions?.forEach((option: any) => {
                map.set(`${option.name}:${option.value.toLowerCase()}`, variant);
            });
        });

        return map;
    }, [variants]);

    const userShopname = standAlone ? window.kefi_bundles.shop : shopify.config.shop;
    function notExistVariants(options: any) {
        const result: any = [];

        // fxn to create combinations recursively
        function combine(arr: any, index: any, current: any) {
            if (index === arr.length) {
                result.push(current.join(OPTION_SEPARATOR));
                return;
            }

            for (let i = 0; i < arr[index].values.length; i++) {
                combine(arr, index + 1, [...current, arr[index].values[i]]);
            }
        }

        combine(options, 0, []);

        const variantsAv = variants.map((v) => v.selectedOptions.map((o: any) => o.value).join(OPTION_SEPARATOR));
        const outOfStockVaraints = variants
            .filter((v) => v.availableForSale == false)
            .map((v) => v.selectedOptions.map((o: any) => o.value).join(OPTION_SEPARATOR));

        const missingVariants = result.filter((item: string) => !variantsAv.includes(item));

        return [...missingVariants, ...outOfStockVaraints];
    }

    const unavailable_combinations = notExistVariants(options);
    console._log("UNAVAILABLE COMBINATIONS: ", unavailable_combinations);

    const handleSwatchClick = (optionValue: string, optionName: string, optionIndex: number) => {
        const currentSelectedVariant = selected[productCardIndex];
        const updatedSelectedOptions = [...currentSelectedVariant.selectedOptions];

        updatedSelectedOptions[optionIndex] = { ...updatedSelectedOptions[optionIndex], value: optionValue };

        const selectedOptionsArray = updatedSelectedOptions.map((option) => option.value);
        // console._log({ selectedOptionsArray });

        const matchingVariant = findSelectedVariant(selectedOptionsArray, optionIndex);

        if (matchingVariant) {
            const updatedSelected = [...selected];
            updatedSelected[productCardIndex] = {
                ...matchingVariant,
                copyPrice: matchingVariant.price,
            };

            handleChange(updatedSelected);
        } else {
            console._log("Matching varint not found, means it doesnt exist.");
        }
    };

    const isSelected = (optionName: string, value: string) => {
        const selectedVariant = selected[productCardIndex];
        if (selectedVariant) {
            return selectedVariant.selectedOptions?.some(
                (option: any) => option.name === optionName && option.value === value,
            );
        }
        return false;
    };

    const findSelectedVariant = (selectedOptionsArray: string[], optionIndex?: number) => {
        let exactMatch: any = null;
        let nextMatch: any = null;

        for (const variant of variants) {
            const hasAllSelectedOptions = selectedOptionsArray.every(
                (selectedValue, i) => variant.selectedOptions[i].value === selectedValue,
            );
            if (hasAllSelectedOptions) {
                exactMatch = {
                    ...variant,
                    copyPrice: variant.price,
                };
            } else if (optionIndex !== undefined) {
                const hasAllSelectedOptions = selectedOptionsArray
                    .slice(0, optionIndex + 1)
                    .every((selectedValue, i) => variant.selectedOptions[i].value === selectedValue);
                if (hasAllSelectedOptions) {
                    nextMatch = {
                        ...variant,
                        copyPrice: variant.price,
                    };
                }
                // return next available variant
                console._log("Variant not found for options: ", selectedOptionsArray);
            }
        }
        return exactMatch || nextMatch;
    };

    const isCombinationUnavailable = (combination: string) => {
        return unavailable_combinations.includes(combination);
    };

    function isOptionAvailable(curCombArr: any[], index: number, value: string): boolean {
        let isAvailable = false;
        curCombArr[index] = value; // set the value for current option

        variants.forEach((variant) => {
            if (variant.availableForSale == false || isAvailable) return; // skip unavailable variants

            const variantOptions = variant.selectedOptions.map((o: any) => o.value);

            // every option up to current index should match

            if (variantOptions.slice(0, index + 1).every((val: string, idx: number) => val === curCombArr[idx]))
                isAvailable = true;
        });

        return isAvailable;
    }

    const generateCurrentCombination = () => {
        const selectedOptions = selected[productCardIndex]?.selectedOptions;
        return selectedOptions?.map((option: any) => option.value).join(OPTION_SEPARATOR) || "";
    };

    const renderSwatches = (option: any, metafield: any) => {
        let displayConfig = null;
        const shopCheck =
            (userShopname === SPORTS_TOP_URL ||
                userShopname === MAYUR_TEST_STORE ||
                userShopname === "anurag-1010.myshopify.com") &&
            bundleConfig.bundle_type === BundleTypes.STANDARD &&
            bundleConfig.selected_template_standard !== AvailableStandardTemplates.HORIZONTAL_BASIC;
        const isSideLabel = shopCheck || bundleConfig?.variant_label_position === "beside";

        try {
            const parsed = JSON.parse(metafield?.value);
            // Option names arrive translated on localized storefronts, so resolve by option id first.
            displayConfig = findSwatchEntryForOption(
                parsed.options,
                option,
                options.findIndex((opt) => opt.id === option.id),
                options.length,
            );
        } catch {
            displayConfig = null;
        }

        if (!displayConfig) return null;

        // common helpers
        const currentCombination = `${generateCurrentCombination()}`;
        const curCombArr = currentCombination.split(OPTION_SEPARATOR);
        const optionIndex = options.findIndex((opt) => opt.name === option.name);

        const generateCurrentCombinationForOption = (optionName: string): string => {
            const index = options.findIndex((opt) => opt.name === optionName); // get index
            return curCombArr[index] ?? ""; // return selected value from current combination
        };
        let swatches_select_color;
        if (isCart) {
            swatches_select_color = upsellDesign?.swatches_select_color || "#000000"; // for cart
        } else {
            swatches_select_color = bundlesDesign?.variant_selector_text_color || "#000000"; // for bundles
        }

        const SingleLabelSwatch = ({ option, value, handler = () => {}, clickable = true }: any) => {
            const isOptionSelected = isSelected(option.name, value);
            const newComb = [...curCombArr];
            newComb[optionIndex] = value;
            const newCombStr = newComb.join(OPTION_SEPARATOR);
            const isUnavailable = isCombinationUnavailable(newCombStr);
            return (
                <div className={styles.labelSwatchButtonParent}>
                    <button
                        key={value}
                        className={styles.labelSwatchButton}
                        onClick={handler}
                        disabled={isUnavailable}
                        title={isUnavailable ? "Unavailable" : value}
                        style={{
                            borderRadius:
                                bundleConfig?.swatchShape === "square"
                                    ? 0
                                    : bundleConfig?.swatchShape === "circle"
                                      ? "100px"
                                      : bundleConfig?.swatchShape === "rounded"
                                        ? "10px"
                                        : "6px",
                            cursor: isUnavailable ? "not-allowed" : clickable ? "pointer" : "default",
                            // aspectRatio: "1/1",
                            backgroundColor: isUnavailable
                                ? "#f5f5f5" + "ff"
                                : isOptionSelected
                                  ? swatches_select_color
                                  : "transparent",
                            border: isOptionSelected
                                ? `2px solid ${swatches_select_color}`
                                : `1px solid ${swatches_select_color + "cc"}`,
                            color: isUnavailable
                                ? "#a9a9a9"
                                : isOptionSelected
                                  ? hexToHsba(swatches_select_color).brightness >= 0.5
                                      ? "#000000"
                                      : "#FFFFFF"
                                  : bundlesDesign?.variant_selector_text_color || "#000000",

                            minWidth: bundleConfig.swatchSize * 2,
                            width: "fit-content",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textWrap: "wrap",
                            fontSize: bundlesDesign?.variant_selector_text_size,
                            fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                            fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                            fontFamily:
                                bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                    ? "inherit"
                                    : bundlesDesign?.bundle_widget_font_family,
                            height: "auto",
                        }}
                    >
                        {value}
                    </button>
                    {isUnavailable && <span className={styles.customUnavailableOverlay} title="Unavailable" />}
                </div>
            );
        };

        // LABEL CASE
        if (displayConfig.displayType === "label") {
            return (
                <div
                    title={selected[productCardIndex]?.title || ""}
                    key={option.id}
                    className={styles.variantContainer}
                    style={{
                        width: bundleConfig?.use_compact_spacing || isSideLabel ? "fit-content" : undefined,
                        minWidth: bundleConfig?.use_compact_spacing || isSideLabel ? 0 : undefined,
                        flexDirection: isSideLabel ? "row" : undefined,
                        alignItems: isSideLabel ? "center" : undefined,
                        gap: isSideLabel ? "4px" : undefined,
                    }}
                >
                    {!hideLabel && (
                        <label
                            className={styles.selectLabel}
                            style={{
                                color: bundlesDesign?.variant_selector_text_color,
                                fontSize: bundlesDesign?.variant_selector_text_size,
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                                wordBreak: isSideLabel ? "normal" : "break-word",
                                margin: 0,
                            }}
                        >
                            {option.name}
                            {isSideLabel ? ":" : ""}
                        </label>
                    )}
                    <div className={styles.labelSwatchAllOptions}>
                        {option.values?.length > 0 &&
                            option.values.map((value: string) => {
                                return (
                                    <SingleLabelSwatch
                                        option={option}
                                        value={value}
                                        clickable={!(option.values?.length == 1)}
                                        handler={() => handleSwatchClick(value, option.name, optionIndex)}
                                    />
                                );
                            })}
                    </div>
                </div>
            );
        }

        // DROPDOWN CASE
        if (displayConfig.displayType === "dropdown") {
            const selectedValue = generateCurrentCombinationForOption(option.name); // helper fn for selected val
            // STEP 1: Generate dropdownOptions array from option.values
            const dropdownOptions = option.values.map((val: string) => ({
                value: val,
                isUnavailable: !isOptionAvailable(curCombArr, optionIndex, val),
            }));

            // STEP 2: Find selected option object from dropdownOptions
            const selectedOptionObj = dropdownOptions.find(
                (opt: { value: string; isUnavailable: boolean }) => opt.value === selectedValue,
            );

            return (
                <div
                    key={option.id}
                    className={styles.variantContainer}
                    style={{
                        width:
                            bundleConfig?.use_compact_spacing || isSideLabel
                                ? "fit-content"
                                : isFullWidthSwatchTemplate
                                  ? selected?.length > 1
                                      ? "87%"
                                      : "100%"
                                  : undefined,
                        minWidth: bundleConfig?.use_compact_spacing || isSideLabel ? 0 : undefined,
                        flexGrow: bundleConfig?.bundleType === BundleTypes.FBT ? 1 : undefined,
                        flexDirection: isSideLabel ? "row" : undefined,
                        alignItems: isSideLabel ? "center" : undefined,
                        gap: isSideLabel ? "4px" : undefined,
                    }}
                >
                    {!hideLabel && (
                        <label
                            className={styles.selectLabel}
                            title={option.name}
                            style={{
                                color: bundlesDesign?.variant_selector_text_color,
                                fontSize: bundlesDesign?.variant_selector_text_size,
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                                wordBreak: isSideLabel ? "normal" : "break-word",
                                margin: 0,
                                ...(hideLabel && bundleConfig?.use_compact_spacing
                                    ? { height: 0, overflow: "hidden", visibility: "hidden" as const }
                                    : {}),
                            }}
                        >
                            {option.name}
                            {isSideLabel ? ":" : ""}
                        </label>
                    )}
                    {/* {option.values?.length > 1 && (
                        <select
                            value={selectedValue}
                            className={styles.select}
                            onChange={(e) => handleSwatchClick(e.target.value, option.name, optionIndex)} // same click handler
                            style={{
                                fontSize: bundlesDesign?.variant_selector_text_size,

                                // @ts-expect-error required
                                "--customColor": swatches_select_color ?? "#383838",
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                                maxWidth: "70%",
                            }}
                        >
                            {option.values.map((value: string) => {
                                const newComb = [...curCombArr]; // clone current combo

                                const isAvailable = isOptionAvailable(newComb, optionIndex, value); // check unavailable

                                return (
                                    <option key={value} value={value} disabled={!isAvailable}>
                                        {value}
                                    </option>
                                );
                            })}
                        </select>
                    )} */}
                    <CustomDropdown
                        selectedValue={selectedOptionObj}
                        // All dropdown option objects with isUnavailable status
                        options={dropdownOptions}
                        onSelect={(opt: any) => handleSwatchClick(opt.value, option.name, optionIndex)} // same click handler
                        // Optional: swatch styling or display configs
                        swatchType={null}
                        swatchSize={bundlesDesign?.swatchSize || 18}
                        swatchShape={bundlesDesign?.swatchShape || "rounded"}
                        // Theme/styling config
                        swatches_select_color={bundlesDesign?.variant_selector_text_color || "#383838"}
                        bundlesDesign={bundlesDesign}
                        standAlone={standAlone}
                        bundleConfig={bundleConfig}
                    />
                </div>
            );
        }

        // SWATCHES CASE (color or image)
        if (displayConfig.displayType === "swatch") {
            // CASE: dropdown layout → render one dropdown only
            if (displayConfig.swatchLayout === "dropdown") {
                const dropdownOptions = option.values.map((val: string, idx: number) => {
                    const variant = variantMap.get(`${option.name}:${val.toLowerCase()}`);
                    const swatchValue = findSwatchEntryForValue(
                        displayConfig?.swatchValues,
                        val,
                        idx,
                        option.values.length,
                    );
                    const imageOrColor =
                        displayConfig.swatchType === "image"
                            ? swatchValue?.image || variant?.image?.originalSrc
                            : swatchValue?.color || "#ccc";

                    const newComb = [...curCombArr];
                    newComb[optionIndex] = val;
                    const newCombStr = newComb.join(OPTION_SEPARATOR);
                    const isUnavailable = isCombinationUnavailable(newCombStr);

                    return displayConfig.swatchType === "image"
                        ? { value: val, image: imageOrColor, isUnavailable }
                        : { value: val, color: imageOrColor, isUnavailable };
                });

                return (
                    <div
                        key={option.id}
                        className={styles.variantContainer}
                        style={{
                            width:
                                bundleConfig?.use_compact_spacing || isSideLabel
                                    ? "fit-content"
                                    : isFullWidthSwatchTemplate
                                      ? selected?.length > 1
                                          ? "87%"
                                          : "100%"
                                      : undefined,
                            minWidth: bundleConfig?.use_compact_spacing || isSideLabel ? 0 : undefined,
                            flexDirection: isSideLabel ? "row" : undefined,
                            alignItems: isSideLabel ? "center" : undefined,
                            gap: isSideLabel ? "4px" : undefined,
                        }}
                    >
                        {!hideLabel && (
                            <label
                                className={styles.selectLabel}
                                style={{
                                    color: bundlesDesign?.variant_selector_text_color,
                                    fontSize: bundlesDesign?.variant_selector_text_size,
                                    fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                    fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                    fontFamily:
                                        bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                            ? "inherit"
                                            : bundlesDesign?.bundle_widget_font_family,
                                    wordBreak: isSideLabel ? "normal" : "break-word",
                                    margin: 0,
                                    ...(hideLabel && bundleConfig?.use_compact_spacing
                                        ? { height: 0, overflow: "hidden", visibility: "hidden" as const }
                                        : {}),
                                }}
                            >
                                {option.name}
                                {isSideLabel ? ":" : ""}
                            </label>
                        )}
                        <CustomDropdown
                            selectedValue={dropdownOptions.find((opt: any) => isSelected(option.name, opt.value))}
                            options={dropdownOptions}
                            onSelect={(opt: any) => handleSwatchClick(opt.value, option.name, optionIndex)}
                            swatchType={displayConfig.swatchType} // pass swatchType
                            swatches_select_color={swatches_select_color}
                            bundlesDesign={bundlesDesign}
                            swatchSize={bundleConfig?.swatchSize}
                            swatchShape={bundleConfig?.swatchShape}
                            standAlone={standAlone}
                            bundleConfig={bundleConfig}
                        />
                    </div>
                );
            }

            // CASE: inline layout → render swatches in tooltip
            return (
                <div
                    key={option.id}
                    className={styles.variantContainer}
                    style={{
                        width:
                            bundleConfig?.use_compact_spacing || isSideLabel
                                ? "fit-content"
                                : isFullWidthSwatchTemplate
                                  ? selected?.length > 1
                                      ? "87%"
                                      : "100%"
                                  : undefined,
                        minWidth: bundleConfig?.use_compact_spacing || isSideLabel ? 0 : undefined,
                        flexDirection: isSideLabel ? "row" : undefined,
                        alignItems: isSideLabel ? "center" : undefined,
                        gap: isSideLabel ? "4px" : undefined,
                    }}
                >
                    {!hideLabel && (
                        <label
                            className={styles.selectLabel}
                            style={{
                                color: bundlesDesign?.variant_selector_text_color,
                                fontSize: bundlesDesign?.variant_selector_text_size,
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                                wordBreak: isSideLabel ? "normal" : "break-word",
                                margin: 0,
                                ...(hideLabel && bundleConfig?.use_compact_spacing
                                    ? { height: 0, overflow: "hidden", visibility: "hidden" as const }
                                    : {}),
                            }}
                        >
                            {option.name}
                            {isSideLabel ? ":" : ""}
                        </label>
                    )}
                    <div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
                        {option.values.map((value: string, idx: number) => {
                            const isOptionSelected = isSelected(option.name, value);
                            const newComb = [...curCombArr];
                            newComb[optionIndex] = value;
                            const newCombStr = newComb.join(OPTION_SEPARATOR);
                            const isUnavailable = isCombinationUnavailable(newCombStr);

                            // SWATCH TYPE - color
                            if (displayConfig.swatchType === "color") {
                                const swatchColor =
                                    findSwatchEntryForValue(
                                        displayConfig?.swatchValues,
                                        value,
                                        idx,
                                        option.values.length,
                                    )?.color || "#ccc";

                                return (
                                    <Tooltip key={value} text={value}>
                                        <div
                                            onClick={() =>
                                                !isUnavailable && handleSwatchClick(value, option.name, optionIndex)
                                            }
                                            className={styles.colorSwatchParent}
                                            style={{
                                                width: bundleConfig?.swatchSize + 5 || 25,
                                                height: bundleConfig?.swatchSize + 5 || 25,
                                                borderRadius:
                                                    bundleConfig?.swatchShape === "square"
                                                        ? 0
                                                        : bundleConfig?.swatchShape === "circle"
                                                          ? "50%"
                                                          : bundleConfig?.swatchShape === "rounded" &&
                                                              bundleConfig?.swatchSize > 20
                                                            ? "10px"
                                                            : bundleConfig?.swatchShape === "rounded"
                                                              ? "5px"
                                                              : "50%",
                                                border: isOptionSelected
                                                    ? `2px solid ${swatches_select_color}`
                                                    : "2px solid transparent",
                                                backgroundColor: swatchColor,
                                                cursor: isUnavailable ? "not-allowed" : "pointer",
                                                boxSizing: "border-box",
                                                display: "block",
                                            }}
                                            title={isUnavailable ? "Unavailable" : ""}
                                        >
                                            {isUnavailable && <span className={styles.customUnavailableOverlay} />}
                                            {isOptionSelected && (
                                                <img
                                                    src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_5.png?v=1722574411"
                                                    alt="Selected"
                                                    className={styles.customSelectedIcon}
                                                />
                                            )}
                                        </div>
                                    </Tooltip>
                                );
                            }

                            // SWATCH TYPE - image
                            if (displayConfig.swatchType === "image") {
                                const variant = variantMap.get(`${option.name}:${value.toLowerCase()}`);
                                const imgSrc =
                                    findSwatchEntryForValue(
                                        displayConfig?.swatchValues,
                                        value,
                                        idx,
                                        option.values.length,
                                    )?.image ||
                                    variant?.image?.originalSrc ||
                                    "";

                                return (
                                    <Tooltip key={value} text={value}>
                                        <div
                                            onClick={() =>
                                                !isUnavailable && handleSwatchClick(value, option.name, optionIndex)
                                            }
                                            className={styles.imageSwatchParent}
                                            style={{
                                                width: bundleConfig?.swatchSize + 5 || 25,
                                                height: bundleConfig?.swatchSize + 5 || 25,
                                                borderRadius:
                                                    bundleConfig?.swatchShape === "square"
                                                        ? 0
                                                        : bundleConfig?.swatchShape === "circle"
                                                          ? "50%"
                                                          : bundleConfig?.swatchShape === "rounded" &&
                                                              bundleConfig?.swatchSize > 20
                                                            ? "10px"
                                                            : bundleConfig?.swatchShape === "rounded"
                                                              ? "5px"
                                                              : "50%",
                                                border: isOptionSelected
                                                    ? `2px solid ${swatches_select_color}`
                                                    : "2px solid transparent",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                cursor: isUnavailable ? "not-allowed" : "pointer",
                                                lineHeight: "normal",
                                                overflow: "hidden",
                                            }}
                                        >
                                            {imgSrc ? (
                                                <img
                                                    src={imgSrc}
                                                    alt={value}
                                                    className={styles.imageSwatchImage}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        pointerEvents: isUnavailable ? "none" : "auto",
                                                    }}
                                                />
                                            ) : (
                                                <Icon source={ImageIcon} />
                                            )}
                                            {isUnavailable && (
                                                <span className={styles.customUnavailableOverlay} title="Unavailable" />
                                            )}
                                            {imgSrc && isOptionSelected && (
                                                <img
                                                    src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_5.png?v=1722574411"
                                                    alt="Selected"
                                                    className={styles.customSelectedIcon}
                                                />
                                            )}
                                        </div>
                                    </Tooltip>
                                );
                            }

                            return null;
                        })}
                    </div>
                </div>
            );
        }

        return null; // fallback
    };

    const isFullWidthSwatchTemplate =
        bundleConfig?.selected_template_standard === AvailableStandardTemplates.HORIZONTAL_BASIC ||
        bundleConfig?.selected_template_fbt === AvailableFBTTemplates.HORIZONTAL ||
        bundleConfig?.selected_template_bxgy === AvailableBXGYTemplates.HORIZONTAL_BASIC ||
        bundleConfig?.bundle_type === BundleTypes.BUNDLE_BUILDER ||
        bundleConfig?.bundle_type === BundleTypes.BUNDLE_BUILDER_CTA ||
        bundleConfig?.bundle_type === BundleTypes.BB_PLACEHOLDER;

    return (
        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="swatchesSelector">
            <div
                className={styles.optionsOuterContainer}
                style={{
                    alignItems:
                        userShopname === SPORTS_TOP_URL ||
                        userShopname === MAYUR_TEST_STORE ||
                        userShopname === "anurag-1010.myshopify.com"
                            ? "center"
                            : undefined,
                }}
            >
                {!hideSerialNumber &&
                    selected?.length > 1 &&
                    (bundleConfig?.bundle_type == BundleTypes.MIX_MATCH ||
                        bundleConfig?.bundle_type == BundleTypes.MIX_MATCH_SECTIONAL ||
                        bundleConfig?.bundle_type == BundleTypes.VOLUME_DISCOUNT ||
                        bundleConfig?.bundle_type == BundleTypes.STANDARD) && (
                        <div
                            style={{
                                color: bundlesDesign?.variant_selector_text_color ?? "#383838",
                                paddingTop: bundleConfig?.variant_label_position === "beside" ? "4px" : undefined,
                                fontSize: bundlesDesign?.variant_selector_text_size - 1,
                                minWidth: bundlesDesign?.variant_selector_text_size - 2,
                            }}
                            className={styles.serialNumberContainer}
                        >
                            <span>{productCardIndex + 1 + "."}</span>
                        </div>
                    )}
                <div
                    className={styles.VariantOptionContainer}
                    style={{
                        flexDirection:
                            userShopname === SPORTS_TOP_URL ||
                            userShopname === MAYUR_TEST_STORE ||
                            userShopname === "anurag-1010.myshopify.com "
                                ? "column"
                                : undefined,
                    }}
                >
                    {options.map((option) => renderSwatches(option, metafield))}
                </div>
            </div>
        </InspectorEditableBlock>
    );
};

export const OldCustomSwatches = ({
    variants = [],
    selected,
    handleChange = () => {},
    productCardIndex,
    options,
    metafield,
    bundlesDesign,
    bundleConfig,
    isCart = false,
    upsellDesign = {},
    maxWidth = "",
}: {
    variants: any[];
    selected: any[];
    handleChange: any;
    productCardIndex: number;
    options: any[];
    standAlone: boolean;
    bundlesDesign: any;
    bundleConfig: any;
    metafield?: any;
    isCart?: boolean;
    upsellDesign?: any;
    maxWidth?: string | number;
}) => {
    // console._log({ options });
    function notExistVariants(options: any) {
        const result: any = [];

        // fxn to create combinations recursively
        function combine(arr: any, index: any, current: any) {
            if (index === arr.length) {
                result.push(current.join(OPTION_SEPARATOR));
                return;
            }

            for (let i = 0; i < arr[index].values.length; i++) {
                combine(arr, index + 1, [...current, arr[index].values[i]]);
            }
        }

        combine(options, 0, []);

        const variantsAv = variants.map((v) => v.selectedOptions.map((o: any) => o.value).join(OPTION_SEPARATOR));
        const outOfStockVaraints = variants
            .filter((v) => v.availableForSale == false)
            .map((v) => v.selectedOptions.map((o: any) => o.value).join(OPTION_SEPARATOR));

        const missingVariants = result.filter((item: string) => !variantsAv.includes(item));

        return [...missingVariants, ...outOfStockVaraints];
    }

    const unavailable_combinations = notExistVariants(options);
    console._log("UNAVAILABLE COMBINATIONS: ", unavailable_combinations);

    const handleSwatchClick = (optionValue: string, optionName: string, optionIndex: number) => {
        const currentSelectedVariant = selected[productCardIndex];
        const updatedSelectedOptions = [...currentSelectedVariant.selectedOptions];

        updatedSelectedOptions[optionIndex] = { ...updatedSelectedOptions[optionIndex], value: optionValue };

        const selectedOptionsArray = updatedSelectedOptions.map((option) => option.value);
        // console._log({ selectedOptionsArray });

        const matchingVariant = findSelectedVariant(selectedOptionsArray, optionIndex);

        if (matchingVariant) {
            const updatedSelected = [...selected];
            updatedSelected[productCardIndex] = {
                ...matchingVariant,
                copyPrice: matchingVariant.price,
            };

            handleChange(updatedSelected);
        } else {
            console._log("Matching varint not found, means it doesnt exist.");
        }
    };

    const isSelected = (optionName: string, value: string) => {
        const selectedVariant = selected[productCardIndex];
        if (selectedVariant) {
            return selectedVariant.selectedOptions?.some(
                (option: any) => option.name === optionName && option.value === value,
            );
        }
        return false;
    };

    const findSelectedVariant = (selectedOptionsArray: string[], optionIndex?: number) => {
        let exactMatch: any = null;
        let nextMatch: any = null;

        for (const variant of variants) {
            const hasAllSelectedOptions = selectedOptionsArray.every(
                (selectedValue, i) => variant.selectedOptions[i].value === selectedValue,
            );
            if (hasAllSelectedOptions) {
                exactMatch = {
                    ...variant,
                    copyPrice: variant.price,
                };
            } else if (optionIndex !== undefined) {
                const hasAllSelectedOptions = selectedOptionsArray
                    .slice(0, optionIndex + 1)
                    .every((selectedValue, i) => variant.selectedOptions[i].value === selectedValue);
                if (hasAllSelectedOptions) {
                    nextMatch = {
                        ...variant,
                        copyPrice: variant.price,
                    };
                }
                // return next available variant
                console._log("Variant not found for options: ", selectedOptionsArray);
            }
        }
        return exactMatch || nextMatch;
    };

    const isCombinationUnavailable = (combination: string) => {
        return unavailable_combinations.includes(combination);
    };

    function isOptionAvailable(curCombArr: any[], index: number, value: string): boolean {
        let isAvailable = false;
        curCombArr[index] = value; // set the value for current option

        variants.forEach((variant) => {
            if (variant.availableForSale == false || isAvailable) return; // skip unavailable variants

            const variantOptions = variant.selectedOptions.map((o: any) => o.value);

            // every option up to current index should match

            if (variantOptions.slice(0, index + 1).every((val: string, idx: number) => val === curCombArr[idx]))
                isAvailable = true;
        });

        return isAvailable;
    }

    const generateCurrentCombination = () => {
        const selectedOptions = selected[productCardIndex]?.selectedOptions;
        return selectedOptions?.map((option: any) => option.value).join(OPTION_SEPARATOR) || "";
    };

    const renderSwatches = (option: any, metafield: any) => {
        let displayConfig = null;

        try {
            const parsed = JSON.parse(metafield?.value);
            displayConfig = parsed.options?.find(
                (o: any) => o.variantType?.toLowerCase() === option.name?.toLowerCase(),
            );
        } catch {
            displayConfig = null;
        }

        if (!displayConfig) return null;

        // common helpers
        const currentCombination = `${generateCurrentCombination()}`;
        const curCombArr = currentCombination.split(OPTION_SEPARATOR);
        const optionIndex = options.findIndex((opt) => opt.name === option.name);

        const generateCurrentCombinationForOption = (optionName: string): string => {
            const index = options.findIndex((opt) => opt.name === optionName); // get index
            return curCombArr[index] ?? ""; // return selected value from current combination
        };
        let swatches_select_color;
        if (isCart) {
            swatches_select_color = upsellDesign?.swatches_select_color || "#000000"; // for cart
        } else {
            swatches_select_color = bundlesDesign?.swatches_select_color || "#000000"; // for bundles
        }

        const SingleLabelSwatch = ({ option, value, handler = () => {}, clickable = true }: any) => {
            const isOptionSelected = isSelected(option.name, value);
            const newComb = [...curCombArr];
            newComb[optionIndex] = value;
            const newCombStr = newComb.join(OPTION_SEPARATOR);
            const isUnavailable = isCombinationUnavailable(newCombStr);
            return (
                <div style={{ position: "relative" }}>
                    <button
                        key={value}
                        className={styles.swatch}
                        onClick={handler}
                        disabled={isUnavailable}
                        title={isUnavailable ? "Unavailable" : ""}
                        style={{
                            padding: "4px 6px",
                            borderRadius:
                                bundleConfig?.swatchShape === "square"
                                    ? 0
                                    : bundleConfig?.swatchShape === "circle"
                                      ? "100px"
                                      : bundleConfig?.swatchShape === "rounded"
                                        ? "10px"
                                        : "6px",
                            cursor: isUnavailable ? "not-allowed" : clickable ? "pointer" : "default",
                            backgroundColor: isUnavailable
                                ? "#f5f5f5" + "ff"
                                : isOptionSelected
                                  ? "transparent"
                                  : "transparent",
                            border: isOptionSelected
                                ? `2px solid ${swatches_select_color}`
                                : `1px solid ${swatches_select_color + "cc"}`,
                            color: isUnavailable
                                ? "#a9a9a9"
                                : isOptionSelected
                                  ? swatches_select_color
                                  : swatches_select_color,
                            fontSize: 12,
                            minWidth: "fit-content",
                            width:
                                typeof bundleConfig?.swatchSize === "number"
                                    ? Math.max(bundleConfig.swatchSize * 2, 40)
                                    : "fit-content",
                            textTransform: "capitalize",
                            textWrap: "wrap",
                        }}
                    >
                        {value}
                    </button>
                    {isUnavailable && (
                        <span
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                cursor: "not-allowed",
                                height: "100%",
                                backgroundImage:
                                    "linear-gradient(45deg, transparent 48%, rgba(255, 0, 0, 0.8) 50%, transparent 52%)",
                                borderRadius: "50%",
                                zIndex: 2,
                            }}
                            title="Unavailable"
                        />
                    )}
                </div>
            );
        };

        // LABEL CASE
        if (displayConfig.displayType === "label") {
            return (
                <div
                    key={option.id}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        gap: "2px",
                    }}
                >
                    <label
                        className={styles.selectLabel}
                        style={{
                            color: bundlesDesign?.variant_selector_text_color,
                        }}
                    >
                        {option.name}
                    </label>
                    <div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
                        {option.values?.length > 0 &&
                            option.values.map((value: string) => {
                                return (
                                    <SingleLabelSwatch
                                        option={option}
                                        value={value}
                                        clickable={!(option.values?.length == 1)}
                                        handler={() => handleSwatchClick(value, option.name, optionIndex)}
                                    />
                                );
                            })}
                    </div>
                </div>
            );
        }

        // DROPDOWN CASE
        if (displayConfig.displayType === "dropdown") {
            const selectedValue = generateCurrentCombinationForOption(option.name); // helper fn for selected val

            return (
                <div key={option.id} style={{ display: "flex", flexDirection: "column", gap: "2px", maxWidth: "100%" }}>
                    <label
                        className={styles.selectLabel}
                        style={{
                            color: bundlesDesign?.variant_selector_text_color,
                        }}
                    >
                        {option.name}
                        {option.values?.length == 1 && (
                            <span
                                style={{
                                    fontSize: bundlesDesign?.variant_selector_text_size,
                                    fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                    fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                    fontFamily:
                                        bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                            ? "inherit"
                                            : bundlesDesign?.bundle_widget_font_family,
                                }}
                            >
                                : {option.values}
                            </span>
                        )}
                    </label>
                    {option.values?.length > 1 && (
                        <select
                            value={selectedValue}
                            className={styles.select}
                            onChange={(e) => handleSwatchClick(e.target.value, option.name, optionIndex)} // same click handler
                            style={{
                                fontSize: bundlesDesign?.variant_selector_text_size,
                                minHeight: "25px",
                                height: "100%",
                                // @ts-expect-error required
                                "--customColor": swatches_select_color ?? "#383838",
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                            }}
                        >
                            {option.values.map((value: string) => {
                                const newComb = [...curCombArr]; // clone current combo

                                const isAvailable = isOptionAvailable(newComb, optionIndex, value); // check unavailable

                                return (
                                    <option key={value} value={value} disabled={!isAvailable}>
                                        {value}
                                    </option>
                                );
                            })}
                        </select>
                    )}
                </div>
            );
        }

        // SWATCHES CASE (color or image)
        if (displayConfig.displayType === "swatch") {
            // CASE: dropdown layout → render one dropdown only
            if (displayConfig.swatchLayout === "dropdown") {
                const dropdownOptions = option.values.map((val: string, idx: number) => {
                    const imageOrColor =
                        displayConfig.swatchType === "image"
                            ? displayConfig?.swatchValues?.find(
                                  (swatch: any) => swatch.value.toLowerCase() === val.toLowerCase(),
                              )?.image || variants[idx]?.image?.originalSrc
                            : displayConfig?.swatchValues?.find(
                                  (swatch: any) => swatch.value.toLowerCase() === val.toLowerCase(),
                              )?.color || "#ccc";

                    const newComb = [...curCombArr];
                    newComb[optionIndex] = val;
                    const newCombStr = newComb.join(OPTION_SEPARATOR);
                    const isUnavailable = isCombinationUnavailable(newCombStr);

                    return displayConfig.swatchType === "image"
                        ? { value: val, image: imageOrColor, isUnavailable }
                        : { value: val, color: imageOrColor, isUnavailable };
                });

                return (
                    <div
                        key={option.id}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            gap: 2,
                            maxWidth: maxWidth ? maxWidth : dropdownOptions?.length > 1 ? "100%" : "max-content",
                        }}
                    >
                        <label
                            className={styles.selectLabel}
                            style={{
                                color: bundlesDesign?.variant_selector_text_color,
                            }}
                        >
                            {option.name}
                        </label>
                        <OldCustomDropdown
                            selectedValue={dropdownOptions.find((opt: any) => isSelected(option.name, opt.value))}
                            options={dropdownOptions}
                            onSelect={(opt: any) => handleSwatchClick(opt.value, option.name, optionIndex)}
                            swatchType={displayConfig.swatchType} // pass swatchType
                            swatches_select_color={swatches_select_color}
                            bundlesDesign={bundlesDesign}
                            swatchSize={bundleConfig?.swatchSize}
                            swatchShape={bundleConfig?.swatchShape}
                            variants={variants}
                        />
                    </div>
                );
            }

            // CASE: inline layout → render swatches in tooltip
            return (
                <div
                    key={option.id}
                    style={{ display: "flex", justifyContent: "center", flexDirection: "column", gap: 2 }}
                >
                    <label
                        className={styles.selectLabel}
                        style={{
                            color: bundlesDesign?.variant_selector_text_color,
                        }}
                    >
                        {option.name}
                    </label>
                    <div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
                        {option.values.map((value: string, idx: number) => {
                            const isOptionSelected = isSelected(option.name, value);
                            const newComb = [...curCombArr];
                            newComb[optionIndex] = value;
                            const newCombStr = newComb.join(OPTION_SEPARATOR);
                            const isUnavailable = isCombinationUnavailable(newCombStr);

                            // SWATCH TYPE - color
                            if (displayConfig.swatchType === "color") {
                                const swatchColor =
                                    displayConfig?.swatchValues?.find(
                                        (swatch: any) => swatch.value.toLowerCase() === value.toLowerCase(),
                                    )?.color || "#ccc";

                                return (
                                    <Tooltip key={value} text={value}>
                                        <div
                                            onClick={() =>
                                                !isUnavailable && handleSwatchClick(value, option.name, optionIndex)
                                            }
                                            style={{
                                                position: "relative",
                                                width: bundleConfig?.swatchSize + 5 || 25,
                                                height: bundleConfig?.swatchSize + 5 || 25,
                                                borderRadius:
                                                    bundleConfig?.swatchShape === "square"
                                                        ? 0
                                                        : bundleConfig?.swatchShape === "circle"
                                                          ? "50%"
                                                          : bundleConfig?.swatchShape === "rounded" &&
                                                              bundleConfig?.swatchSize > 20
                                                            ? "10px"
                                                            : bundleConfig?.swatchShape === "rounded"
                                                              ? "5px"
                                                              : "50%",
                                                border: isOptionSelected
                                                    ? `2px solid ${swatches_select_color}`
                                                    : "2px solid transparent",
                                                backgroundColor: swatchColor,
                                                cursor: isUnavailable ? "not-allowed" : "pointer",
                                                boxSizing: "border-box",
                                                display: "block",
                                            }}
                                            title={isUnavailable ? "Unavailable" : ""}
                                        >
                                            {isUnavailable && (
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        backgroundImage:
                                                            "linear-gradient(45deg, transparent 48%, rgba(255, 0, 0, 0.8) 50%, transparent 52%)",
                                                        borderRadius: "50%",
                                                        zIndex: 2,
                                                    }}
                                                />
                                            )}
                                            {isOptionSelected && (
                                                <img
                                                    src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_5.png?v=1722574411"
                                                    alt="Selected"
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        width: "50%",
                                                        height: "50%",
                                                        borderRadius: "50%",
                                                        objectFit: "contain",
                                                        zIndex: 3,
                                                        transform: "translate(-50%, -50%)",
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </Tooltip>
                                );
                            }

                            // SWATCH TYPE - image
                            if (displayConfig.swatchType === "image") {
                                const imgSrc =
                                    displayConfig?.swatchValues?.find(
                                        (swatch: any) => swatch.value.toLowerCase() === value.toLowerCase(),
                                    )?.image ||
                                    variants[idx]?.image?.originalSrc ||
                                    "";

                                return (
                                    <Tooltip key={value} text={value}>
                                        <div
                                            onClick={() =>
                                                !isUnavailable && handleSwatchClick(value, option.name, optionIndex)
                                            }
                                            style={{
                                                position: "relative",
                                                width: bundleConfig?.swatchSize + 5 || 25,
                                                height: bundleConfig?.swatchSize + 5 || 25,
                                                borderRadius:
                                                    bundleConfig?.swatchShape === "square"
                                                        ? 0
                                                        : bundleConfig?.swatchShape === "circle"
                                                          ? "50%"
                                                          : bundleConfig?.swatchShape === "rounded" &&
                                                              bundleConfig?.swatchSize > 20
                                                            ? "10px"
                                                            : bundleConfig?.swatchShape === "rounded"
                                                              ? "5px"
                                                              : "50%",
                                                border: isOptionSelected
                                                    ? `2px solid ${swatches_select_color}`
                                                    : "1px solid #cbcbcb",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                cursor: isUnavailable ? "not-allowed" : "pointer",
                                                lineHeight: "normal",
                                                overflow: "hidden",
                                            }}
                                        >
                                            {imgSrc ? (
                                                <img
                                                    src={imgSrc}
                                                    alt={value}
                                                    style={{
                                                        width: "94%",
                                                        objectFit: "cover",
                                                        pointerEvents: isUnavailable ? "none" : "auto",
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%)",
                                                        padding: "0px",
                                                    }}
                                                />
                                            ) : (
                                                <Icon source={ImageIcon} />
                                            )}
                                            {isUnavailable && (
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        backgroundImage:
                                                            "linear-gradient(45deg, transparent 48%, rgba(255, 0, 0, 0.8) 50%, transparent 52%)",
                                                        borderRadius: "50%",
                                                        zIndex: 2,
                                                    }}
                                                    title="Unavailable"
                                                />
                                            )}
                                            {imgSrc && isOptionSelected && (
                                                <img
                                                    src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_5.png?v=1722574411"
                                                    alt="Selected"
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        width: "50%",
                                                        height: "50%",
                                                        borderRadius: "50%",
                                                        objectFit: "contain",
                                                        zIndex: 3,
                                                        transform: "translate(-50%, -50%)",
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </Tooltip>
                                );
                            }

                            return null;
                        })}
                    </div>
                </div>
            );
        }

        return null; // fallback
    };

    return (
        <div className={styles.optionsOuterContainer}>
            <div
                style={{
                    position: "relative",
                    display: "flex",
                    gap: "14px",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    width: "100%",
                }}
            >
                {selected?.length > 1 && (
                    <div
                        style={{
                            display: "flex",
                            color: "#383838",
                            fontWeight: 450,
                            fontSize: "11px",
                            minWidth: 10,
                            marginLeft: 8,
                            alignItems: "center",
                            paddingTop: "16px",
                        }}
                    >
                        <span>{productCardIndex + 1 + "."}</span>
                    </div>
                )}
                <div className={styles.VariantOptionContainer}>
                    {options.map((option) => renderSwatches(option, metafield))}
                </div>
            </div>
        </div>
    );
};

const OldCustomDropdown = ({
    selectedValue,
    options,
    onSelect,
    swatchType,
    swatches_select_color,
    bundlesDesign,
    swatchSize,
    swatchShape,
}: any) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const parentContainerRef = useRef<HTMLDivElement>(null);
    const positionRef = useRef({
        top: 0,
        left: 0,
    });

    const handleToggle = () => {
        calculateClientRect();
        setIsOpen(!isOpen);
    };

    const handleSelect = (value: any) => {
        onSelect(value);
        setIsOpen(false);
    };

    const calculateClientRect = () => {
        const rect = parentContainerRef.current?.getBoundingClientRect?.();
        if (!rect) return;

        const { top, left } = rect;
        positionRef.current = { top: top + 30, left };

        if (dropdownRef.current) {
            dropdownRef.current.style.top = top + 30 + "px";
            dropdownRef.current.style.left = left + "px";
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                parentContainerRef.current &&
                !parentContainerRef.current.contains(event.target as Node) // added this check
            ) {
                setIsOpen(false);
            }
        };

        const handleScroll = (e: Event) => {
            const target = e.target as HTMLElement;
            // calculateClientRect();

            // if user is scrolling inside dropdown list (dropdownRef), do nothing
            if (dropdownRef.current && dropdownRef.current.contains(target)) {
                return;
            }

            // else user scrolled outside => close dropdown
            setIsOpen(false);
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            document.addEventListener("scroll", handleScroll, true); // use capture phase
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("scroll", handleScroll, true);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("scroll", handleScroll, true);
        };
    }, [isOpen]);

    return (
        <div ref={parentContainerRef} style={{ position: "relative", display: "inline-block" }}>
            {/* Trigger Button */}
            <div
                onClick={options?.length > 1 ? handleToggle : () => {}}
                style={{
                    position: "relative",
                    borderRadius: "8px",
                    padding: "2px 4px",
                    border: `1px solid ${swatches_select_color}`,
                    cursor: options?.length > 1 ? "pointer" : "default",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    userSelect: "none",
                    color: swatches_select_color,
                    fontSize: bundlesDesign?.variant_selector_text_size,
                    fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                    fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                    fontFamily:
                        bundlesDesign?.bundle_widget_font_family == "Custom Store Font"
                            ? "inherit"
                            : bundlesDesign?.bundle_widget_font_family,
                    minHeight: "25px",
                    // @ts-expect-error required
                    "--customColor": swatches_select_color ?? "#383838",
                }}
            >
                {/* Swatch circle or image */}

                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div
                        style={{
                            width: swatchSize || 19,
                            height: swatchSize || 19,
                            borderRadius:
                                swatchShape === "square"
                                    ? 0
                                    : swatchShape === "circle"
                                      ? "50%"
                                      : swatchShape === "rounded" && swatchSize > 40
                                        ? "10px"
                                        : swatchShape === "rounded"
                                          ? "5px"
                                          : "50%",
                            backgroundColor: selectedValue?.color || "#fff",
                            overflow: "hidden",
                            flexShrink: 0,
                            marginRight: 8,
                            position: "relative",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        {swatchType === "image" && selectedValue?.image && (
                            <img
                                src={selectedValue.image}
                                alt={selectedValue.value}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        )}
                    </div>

                    {/* Selected value text */}

                    <span
                        style={{
                            fontSize: bundlesDesign?.variant_selector_text_size,
                            overflow: "hidden",
                            maxWidth: "70%",
                            width: "max-content",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {selectedValue?.value || "Select"}
                    </span>
                </div>

                {/* Chevron */}
                {options?.length > 1 && (
                    <GoChevronDown
                        style={{
                            color: swatches_select_color,
                            marginLeft: 8,
                            fontSize: bundlesDesign?.variant_selector_text_size || "18px",
                        }}
                    />
                )}
            </div>

            {/* Dropdown Options */}
            {ReactDOM.createPortal(
                <>
                    {isOpen && (
                        <div
                            ref={dropdownRef}
                            style={{
                                position: "fixed",
                                background: "#fff",
                                borderRadius: "8px !important",
                                zIndex: 9999999,
                                width: "auto",
                                display: "flex",
                                maxHeight: "170px",
                                overflow: "auto",

                                border: "1px solid gray",
                                flexDirection: "column",
                                minWidth: "max-content",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                fontSize: bundlesDesign?.variant_selector_text_size,
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family == "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                                ...positionRef.current,
                            }}
                        >
                            {options.map((option: any, idx: number) => {
                                const isUnavailable = option.isUnavailable;
                                const isOptionSelected = selectedValue?.value === option.value;

                                return (
                                    <div
                                        key={idx}
                                        className={`${styles.optionItem} ${
                                            isUnavailable ? styles.unavailable : styles.available
                                        }`}
                                        onClick={() => !isUnavailable && handleSelect(option)}
                                    >
                                        <div
                                            style={{
                                                position: "relative",
                                                width: swatchSize || 19,
                                                height: swatchSize || 19,
                                                borderRadius:
                                                    swatchShape === "square"
                                                        ? 0
                                                        : swatchShape === "circle"
                                                          ? "50%"
                                                          : swatchShape === "rounded" && swatchSize > 40
                                                            ? "10px"
                                                            : swatchShape === "rounded"
                                                              ? "5px"
                                                              : "50%",
                                                border: isOptionSelected
                                                    ? `2px solid ${swatches_select_color}`
                                                    : "2px solid transparent",
                                                backgroundColor:
                                                    swatchType === "color" ? option.color || "#ccc" : undefined,
                                                boxSizing: "border-box",
                                                overflow: "hidden",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                            title={isUnavailable ? "Unavailable" : ""}
                                        >
                                            {swatchType === "image" && option.image && (
                                                <img
                                                    src={option.image}
                                                    alt={option.value}
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "50%",
                                                    }}
                                                />
                                            )}

                                            {isUnavailable && (
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        backgroundImage:
                                                            "linear-gradient(45deg, transparent 48%, rgba(255, 0, 0, 0.8) 50%, transparent 52%)",
                                                        borderRadius: "50%",
                                                        zIndex: 2,
                                                    }}
                                                />
                                            )}

                                            {isOptionSelected && (
                                                <img
                                                    src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_5.png?v=1722574411"
                                                    alt="Selected"
                                                    style={{
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        width: "50%",
                                                        height: "50%",
                                                        borderRadius: "50%",
                                                        objectFit: "contain",
                                                        zIndex: 3,
                                                        transform: "translate(-50%, -50%)",
                                                    }}
                                                />
                                            )}
                                        </div>

                                        <span style={{ flexGrow: 1, fontSize: 14 }}>{option?.value || "Select"}</span>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </>,
                document.body,
            )}
        </div>
    );
};

interface CustomDropdownProps {
    selectedValue: { value: string; color?: string; image?: string; isUnavailable?: boolean } | null;
    options: Array<{ value: string; color: string; image: string; isUnavailable: boolean }>;
    onSelect: (value: string) => void;
    swatchType: "color" | "image" | null;
    swatches_select_color: string;
    bundlesDesign: any;
    swatchSize: number;
    standAlone: boolean;
    swatchShape: "square" | "rounded" | "circle";
    bundleConfig: any;
}

const CustomDropdown = ({
    selectedValue,
    options,
    onSelect,
    swatchType,
    swatches_select_color,
    bundlesDesign,
    swatchSize,
    swatchShape,
    standAlone,
    bundleConfig,
}: CustomDropdownProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const parentContainerRef = useRef<HTMLDivElement>(null);
    const positionRef = useRef({
        top: 0,
        left: 0,
        right: 0,
        minWidth: 0,
    });
    const userShopname = standAlone ? window.kefi_bundles.shop : shopify.config.shop;
    const shopCheck =
        (userShopname === SPORTS_TOP_URL ||
            userShopname === MAYUR_TEST_STORE ||
            userShopname === "anurag-1010.myshopify.com") &&
        bundleConfig.bundle_type === BundleTypes.STANDARD &&
        bundleConfig.selected_template_standard !== AvailableStandardTemplates.HORIZONTAL_BASIC;

    const longestOptionValue = useMemo(
        () =>
            (options || []).reduce(
                (longest, opt) => ((opt?.value?.length || 0) > longest.length ? opt.value : longest),
                "",
            ),
        [options],
    );

    const handleToggle = () => {
        calculateClientRect();
        setIsOpen(!isOpen);
    };

    const handleSelect = (value: any) => {
        onSelect(value);
        setIsOpen(false);
    };

    const calculateClientRect = () => {
        const rect = parentContainerRef.current?.getBoundingClientRect?.();
        if (!rect) return;

        const { top, right, left, width } = rect;
        const windowWidth = window.innerWidth;
        const DROPDOWN_ESTIMATED_WIDTH = 200; // Estimated dropdown width
        const PADDING = 10; // Padding from edge

        // Check if dropdown would overflow on the right
        const wouldOverflowRight = left + DROPDOWN_ESTIMATED_WIDTH > windowWidth - PADDING;

        if (wouldOverflowRight) {
            // Align dropdown to the right edge of the parent
            const rightPosition = windowWidth - right;
            positionRef.current = {
                top: top - 1,
                left: "auto", // flush to viewport left
                right: rightPosition, // flush to viewport right
                minWidth: width,
            };

            if (dropdownRef.current) {
                Object.assign(dropdownRef.current.style, {
                    top: `${positionRef.current.top}px`,
                    right: `${rightPosition}px`, // flush to window right
                    left: "auto",
                    minWidth: `${positionRef.current.minWidth}px`,
                });
            }
        } else {
            // Normal left alignment
            positionRef.current = {
                top: top - 1,
                left: left,
                right: "auto",
                minWidth: width,
            };

            if (dropdownRef.current) {
                Object.assign(dropdownRef.current.style, {
                    top: `${positionRef.current.top}px`,
                    left: `${positionRef.current.left}px`,
                    right: "auto",
                    minWidth: `${positionRef.current.minWidth}px`,
                });
            }
        }
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                parentContainerRef.current &&
                !parentContainerRef.current.contains(event.target as Node) // added this check
            ) {
                setIsOpen(false);
            }
        };

        const handleScroll = (e: Event) => {
            const target = e.target;
            // calculateClientRect();

            // if user is scrolling inside dropdown list (dropdownRef), do nothing
            if (dropdownRef.current && target instanceof Node && dropdownRef.current.contains(target)) {
                return;
            }

            if (target !== document && target !== document.documentElement && target !== document.body) {
                calculateClientRect();
                return;
            }

            // else user scrolled outside => close dropdown
            setIsOpen(false);
        };

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            document.addEventListener("scroll", handleScroll, true); // use capture phase
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("scroll", handleScroll, true);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("scroll", handleScroll, true);
        };
    }, [isOpen]);

    return (
        <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="swatchesSelector">
            <div
                ref={parentContainerRef}
                className={styles.customDropdownParent}
                style={{ width: bundleConfig?.use_compact_spacing ? "100%" : undefined }}
            >
                {/* Trigger Button */}
                <div
                    onClick={options?.length > 1 ? handleToggle : () => {}}
                    style={{
                        // @ts-expect-error required
                        "--customColor": bundlesDesign?.variant_selector_text_color || "#202020",
                        "--customBorderColor": "#dddddd",
                        cursor: options?.length > 1 ? "pointer" : "default",
                        fontSize: bundlesDesign?.variant_selector_text_size,
                        // backgroundColor: bundlesDesign?.product_background_color,
                        fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                        fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                        fontFamily:
                            bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                ? "inherit"
                                : bundlesDesign?.bundle_widget_font_family,
                        paddingRight: bundleConfig?.use_compact_spacing ? 7 : undefined,
                    }}
                    className={styles.customVariantDropdownButton}
                    title={selectedValue?.value || ""}
                >
                    {/* Chevron */}
                    {options?.length > 1 && (
                        <div className={styles.customChevronItemContainer}>
                            {isOpen ? (
                                <GoChevronDown
                                    size={bundlesDesign?.variant_selector_text_size + 3 || 14}
                                    style={{
                                        color: bundlesDesign?.variant_selector_text_color || "#374957",
                                        fontSize: bundlesDesign?.variant_selector_text_size + 3 || "18px",
                                    }}
                                />
                            ) : (
                                <GoChevronRight
                                    size={bundlesDesign?.variant_selector_text_size + 3 || 14}
                                    style={{
                                        color: bundlesDesign?.variant_selector_text_color || "#374957",
                                        fontSize: bundlesDesign?.variant_selector_text_size + 3 || "18px",
                                    }}
                                />
                            )}
                        </div>
                    )}

                    <div className={styles.customSwatchContainer}>
                        {swatchType && (
                            <div
                                className={styles.customSwatchCircle}
                                style={{
                                    // @ts-expect-error required
                                    "--swatchColor": selectedValue?.color || "#fff",
                                    "--swatchSize": `${swatchSize || 19}px`,
                                    "--swatchRadius":
                                        swatchShape === "square"
                                            ? "0px"
                                            : swatchShape === "circle"
                                              ? "50%"
                                              : swatchShape === "rounded" && swatchSize > 40
                                                ? "10px"
                                                : swatchShape === "rounded"
                                                  ? "5px"
                                                  : "50%",
                                }}
                            >
                                {swatchType === "image" && selectedValue?.image && (
                                    <img
                                        src={selectedValue.image}
                                        alt={selectedValue.value}
                                        className={styles.customSwatchImage}
                                    />
                                )}
                            </div>
                        )}

                        <span style={{ display: "inline-grid" }}>
                            <span
                                aria-hidden="true"
                                style={{
                                    gridArea: "1 / 1",
                                    visibility: "hidden",
                                    whiteSpace: "nowrap",
                                    fontSize: bundlesDesign?.variant_selector_text_size,
                                }}
                            >
                                {longestOptionValue}
                            </span>
                            <span
                                className={styles.customSwatchValue}
                                style={{
                                    gridArea: "1 / 1",
                                    // @ts-expect-error required
                                    "--variantTextSize": bundlesDesign?.variant_selector_text_size,
                                    overflow: shopCheck ? "visible" : "hidden",
                                    whiteSpace: shopCheck || isLilSweetTreatStore ? "normal" : undefined,
                                }}
                            >
                                {selectedValue?.value || "Select"}
                            </span>
                        </span>
                    </div>
                </div>

                {/* Dropdown Options */}
                {ReactDOM.createPortal(
                    <>
                        {isOpen && (
                            <div
                                ref={dropdownRef}
                                className={styles.customDropdown}
                                style={{
                                    // @ts-expect-error required
                                    "--variantTextSize": bundlesDesign?.variant_selector_text_size,
                                    "--customColor": "#DDDDDD",
                                    fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                    fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                    // backgroundColor: bundlesDesign?.product_background_color,
                                    fontFamily:
                                        bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                            ? "inherit"
                                            : bundlesDesign?.bundle_widget_font_family,
                                    ...positionRef.current, // keep this dynamic inline
                                }}
                            >
                                <div
                                    onClick={options?.length > 1 ? handleToggle : () => {}}
                                    style={{
                                        // @ts-expect-error required
                                        "--customColor": bundlesDesign?.variant_selector_text_color || "#383838",
                                        cursor: options?.length > 1 ? "pointer" : "default",
                                        fontSize: bundlesDesign?.variant_selector_text_size,
                                        // backgroundColor: bundlesDesign?.product_background_color,
                                        fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                        fontStyle:
                                            bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                        border: "none",
                                        fontFamily:
                                            bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                                ? "inherit"
                                                : bundlesDesign?.bundle_widget_font_family,
                                    }}
                                    className={styles.customVariantDropdownButton}
                                >
                                    {/* Chevron */}
                                    {options?.length > 1 && (
                                        <div className={styles.customChevronItemContainer}>
                                            {isOpen ? (
                                                <GoChevronDown
                                                    size={bundlesDesign?.variant_selector_text_size + 3 || 14}
                                                    style={{
                                                        color: bundlesDesign?.variant_selector_text_color || "#374957",
                                                        fontSize:
                                                            bundlesDesign?.variant_selector_text_size + 3 || "18px",
                                                    }}
                                                />
                                            ) : (
                                                <GoChevronRight
                                                    size={bundlesDesign?.variant_selector_text_size + 3 || 14}
                                                    style={{
                                                        color: bundlesDesign?.variant_selector_text_color || "#374957",
                                                        fontSize:
                                                            bundlesDesign?.variant_selector_text_size + 3 || "18px",
                                                    }}
                                                />
                                            )}
                                        </div>
                                    )}

                                    <div className={styles.customSwatchContainer}>
                                        {swatchType && (
                                            <div
                                                className={styles.customSwatchCircle}
                                                style={{
                                                    // @ts-expect-error required
                                                    "--swatchColor": selectedValue?.color || "#fff",
                                                    "--swatchSize": `${swatchSize || 19}px`,
                                                    "--swatchRadius":
                                                        swatchShape === "square"
                                                            ? "0px"
                                                            : swatchShape === "circle"
                                                              ? "50%"
                                                              : swatchShape === "rounded" && swatchSize > 40
                                                                ? "10px"
                                                                : swatchShape === "rounded"
                                                                  ? "5px"
                                                                  : "50%",
                                                }}
                                            >
                                                {swatchType === "image" && selectedValue?.image && (
                                                    <img
                                                        src={selectedValue.image}
                                                        alt={selectedValue.value}
                                                        className={styles.customSwatchImage}
                                                    />
                                                )}
                                            </div>
                                        )}

                                        <span style={{ display: "inline-grid" }}>
                                            <span
                                                aria-hidden="true"
                                                style={{
                                                    gridArea: "1 / 1",
                                                    visibility: "hidden",
                                                    whiteSpace: "nowrap",
                                                    fontSize: bundlesDesign?.variant_selector_text_size,
                                                }}
                                            >
                                                {longestOptionValue}
                                            </span>
                                            <span
                                                className={styles.customSwatchValue}
                                                style={{
                                                    gridArea: "1 / 1",
                                                    // @ts-expect-error required
                                                    "--variantTextSize": bundlesDesign?.variant_selector_text_size,
                                                    // whiteSpace: "wrap",
                                                    overflow: shopCheck ? "visible" : "hidden",
                                                    whiteSpace:
                                                        shopCheck || isLilSweetTreatStore ? "normal" : undefined,
                                                }}
                                            >
                                                {selectedValue?.value || "Select"}
                                            </span>
                                        </span>
                                    </div>
                                </div>

                                <div
                                    className={styles.dropdownOptionsWrapper}
                                    style={{
                                        borderTop: "1px solid #e0e0e0" /* top separator */,
                                    }}
                                >
                                    {options.map((option, idx) => {
                                        const isUnavailable = option.isUnavailable;
                                        const isOptionSelected = selectedValue?.value === option.value;

                                        return (
                                            <div
                                                key={idx}
                                                className={`${styles.customOptionItem} 
                                                ${isOptionSelected ? styles.customSelected : ""} 
                                                ${isUnavailable ? styles.customUnavailable : styles.customAvailable}`}
                                                style={{
                                                    // @ts-expect-error required
                                                    "--customColor": isOptionSelected ? "#ffffff" : "#DDDDDD",
                                                    fontSize: bundlesDesign?.variant_selector_text_size,
                                                    color:
                                                        isOptionSelected && !swatchType
                                                            ? "#FFFFFF"
                                                            : bundlesDesign?.variant_selector_text_color || "#000000",

                                                    fontWeight:
                                                        bundlesDesign?.variant_selector_text_style?.split(" ")[0] ??
                                                        "450",
                                                    fontStyle:
                                                        bundlesDesign?.variant_selector_text_style?.split(" ")[1] ??
                                                        "normal",

                                                    fontFamily:
                                                        bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                                            ? "inherit"
                                                            : bundlesDesign?.bundle_widget_font_family,
                                                    backgroundColor: swatchType
                                                        ? "transparent"
                                                        : isOptionSelected
                                                          ? bundlesDesign?.variant_selector_text_color || "#383838"
                                                          : lightenHexColor(
                                                                bundlesDesign?.variant_selector_text_color || "#383838",
                                                                86,
                                                            ),
                                                    border: swatchType
                                                        ? isOptionSelected
                                                            ? `2px solid ${swatches_select_color || "#000000"}`
                                                            : "2px solid #DDDDDD"
                                                        : undefined,
                                                }}
                                                onClick={() => !isUnavailable && handleSelect(option)}
                                            >
                                                {swatchType && (
                                                    <div
                                                        className={styles.customSwatchCircle}
                                                        style={{
                                                            // @ts-expect-error required
                                                            "--swatchSize": `${swatchSize || 19}px`,
                                                            "--swatchRadius":
                                                                swatchShape === "square"
                                                                    ? "0px"
                                                                    : swatchShape === "circle"
                                                                      ? "50%"
                                                                      : swatchShape === "rounded" && swatchSize > 40
                                                                        ? "10px"
                                                                        : swatchShape === "rounded"
                                                                          ? "5px"
                                                                          : "50%",
                                                            "--swatchColor":
                                                                swatchType === "color"
                                                                    ? option.color || "#ccc"
                                                                    : "transparent",
                                                            "--swatchBorder": "2px solid transparent",
                                                        }}
                                                        title={isUnavailable ? "Unavailable" : ""}
                                                    >
                                                        {swatchType === "image" && option.image && (
                                                            <img
                                                                src={option.image}
                                                                alt={option.value}
                                                                className={styles.customSwatchImage}
                                                            />
                                                        )}

                                                        {isUnavailable && (
                                                            <span className={styles.customUnavailableOverlay} />
                                                        )}

                                                        {isOptionSelected && (
                                                            <img
                                                                src="https://cdn.shopify.com/s/files/1/0587/0531/3990/files/Vector_5.png?v=1722574411"
                                                                alt="Selected"
                                                                className={styles.customSelectedIcon}
                                                            />
                                                        )}
                                                    </div>
                                                )}

                                                <span style={{ color: "inherit" }}>{option?.value || "Select"}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </>,
                    document.body,
                )}
            </div>
        </InspectorEditableBlock>
    );
};

export const VariantSelector = ({
    variants = [],
    selected,
    handleChange = () => {},
    setUnavailableSelected,
    productCardIndex,
    realProduct,
    bundlesDesign,
    options,
    bundleType,
}: {
    variants: VariantsObj[];
    selected: VariantsObj[];
    bundlesDesign: any;
    handleChange: any;
    bundleLevel: "product" | "variant";
    index: number;
    options: any[];
    setUnavailableSelected: React.Dispatch<
        React.SetStateAction<{
            [key: number]: number[];
        }>
    >;
    productCardIndex: number;
    cardType?: "product" | "discountedProduct"; // <-- New prop for card type
    formId: string | undefined;
    bundleType: string;
    standAlone: boolean;
    realProduct: ProductObj;
    showSerialNumber?: boolean;
}) => {
    // console._log(bundleLevel);

    // console._log("selectedzzzzzzz", selected);

    const handleOptionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        console._log(e.target.value);
        const selectedOptionsArray =
            e.target.value
                ?.split(OPTION_SEPARATOR)
                ?.map((val) => val.trim()) // Trim spaces around each value
                ?.filter((val) => val !== "") || [];
        // console._log("selectedOptionsArray", selectedOptionsArray);
        const matchingVariant = findSelectedVariant(selectedOptionsArray);
        if (matchingVariant) {
            const curVar = selected[productCardIndex];
            const curSub = realProduct?.subscriptions?.find((ss) => ss?.id == curVar?.selling_plan);

            const updatedMatchingVariant = {
                ...matchingVariant,
                selling_plan: curVar?.selling_plan || "",
                copyPrice: matchingVariant.price,
                price: curSub
                    ? getFinalPrice(curSub?.discountType, curSub.discountValue, +matchingVariant.copyPrice).toString()
                    : matchingVariant.price,
            };

            const updatedSelectedVariants = [...selected];
            updatedSelectedVariants[productCardIndex] = updatedMatchingVariant; // <-- Update with productCardIndex
            handleChange(updatedSelectedVariants);
            // Remove this variant index from unavailable state if it was previously marked unavailable
            setUnavailableSelected({});
        } else {
            // e.target.style.border = "2px solid #cc3e3e";
            setUnavailableSelected({});
        }
    };

    const findSelectedVariant = (selectedOptionsArray: string[]) => {
        for (const variant of variants) {
            const hasAllSelectedOptions = selectedOptionsArray.every(
                (selectedValue, i) => variant.selectedOptions[i].value === selectedValue,
            );
            if (hasAllSelectedOptions) {
                return {
                    ...variant,
                    copyPrice: variant.price,
                };
            }
        }
        return null;
    };

    return (
        <InspectorEditableBlock bundleType={bundleType} settingKey="swatchesSelector">
            <div className={styles.optionsOuterContainer}>
                {(selected.length > 1 ||
                    bundleType == BundleTypes.MIX_MATCH ||
                    bundleType == BundleTypes.MIX_MATCH_SECTIONAL) && (
                    <div
                        style={{
                            display: "flex",
                            color: bundlesDesign?.variant_selector_text_color ?? "#383838",
                            fontWeight: 450,
                            fontSize: "11px",
                            width: 10,
                            marginLeft: 8,
                            alignItems: "center",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {<span>{productCardIndex + 1}.</span>}
                    </div>
                )}
                <InspectorEditableBlock bundleType={bundleType} settingKey="variantSelector">
                    <div
                        style={{
                            width: bundleType == BundleTypes.BUNDLE_BUILDER ? "100%" : "",
                            maxWidth: bundleType == BundleTypes.BUNDLE_BUILDER ? "100%" : "90%",
                            position: "relative",
                            paddingLeft:
                                bundleType == BundleTypes.VOLUME_DISCOUNT && selected.length == 1 ? "8px" : "0px",
                        }}
                        className={styles.VariantOptionContainer}
                    >
                        <label
                            className={styles.selectLabel}
                            title={options[0].name}
                            style={{
                                color: bundlesDesign?.variant_selector_text_color,
                                fontSize: bundlesDesign?.variant_selector_text_size,
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                                wordBreak: "break-word",
                            }}
                        >
                            {options[0].name}
                        </label>
                        <select
                            className={styles.select}
                            style={{
                                fontSize: bundlesDesign?.variant_selector_text_size,
                                // @ts-expect-error required
                                "--customColor": bundlesDesign?.variant_selector_text_color ?? "#383838",
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family == "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                            }}
                            name={"product_variants"}
                            id={selected[productCardIndex]?.title} // <-- Unique ID
                            onChange={(e) => handleOptionChange(e)}
                            value={selected[productCardIndex]?.selectedOptions
                                ?.map((o: any) => o.value)
                                .join(OPTION_SEPARATOR)}
                            title={selected[productCardIndex]?.title ? selected[productCardIndex]?.title : ""}
                        >
                            {variants.map((value: any, idx: number) => (
                                <option
                                    className={styles.option}
                                    key={idx}
                                    value={value?.selectedOptions?.map((o: any) => o.value).join(OPTION_SEPARATOR)}
                                    disabled={value?.quantityAvailable <= 0 && !value?.availableForSale}
                                >
                                    {value?.quantityAvailable <= 0 && !value?.availableForSale
                                        ? `${value.title} - N/A`
                                        : value.title}
                                </option>
                            ))}
                        </select>
                        {/* {!!selected[productCardIndex]?.title.length && (
                    <div className={styles.arrowWrapper} onClick={() => {}}>
                        <span
                            style={{
                                visibility: "hidden",
                                marginLeft: standAlone ? "0px" : "5px",
                            }}
                        >
                            {selected[productCardIndex]?.title || ""}
                        </span>
                        <SelectDropArrow />
                    </div>
                )} */}
                    </div>
                </InspectorEditableBlock>
            </div>
        </InspectorEditableBlock>
    );
};

export const VariantSelectorV2 = ({
    variants = [],
    selected,
    handleChange = () => {},
    productCardIndex,
    options,
    bundlesDesign,
    bundleConfig,
    isCart = false,
    upsellDesign = {},
    maxWidth = "",
    standAlone = false,
    hideLabel = false,
    hideSerialNumber = false,
}: {
    variants: any[];
    selected: any[];
    handleChange: any;
    productCardIndex: number;
    options: any[];
    standAlone: boolean;
    bundlesDesign: any;
    bundleConfig: any;
    metafield?: any;
    isCart?: boolean;
    upsellDesign?: any;
    maxWidth?: string | number;
    /** Hide the option name label (e.g. "Size") — used to show it only once above a repeated set of selectors. */
    hideLabel?: boolean;
    /** Hide the "1.", "2." item marker shown when multiple selectors are rendered. */
    hideSerialNumber?: boolean;
}) => {
    options = filterOptionsByVariants(variants, options);

    // console._log({ options });
    const userShopname = standAlone ? window.kefi_bundles.shop : shopify.config.shop;
    function notExistVariants(options: any) {
        const result: any = [];

        // fxn to create combinations recursively
        function combine(arr: any, index: any, current: any) {
            if (index === arr.length) {
                result.push(current.join(OPTION_SEPARATOR));
                return;
            }

            for (let i = 0; i < arr[index].values.length; i++) {
                combine(arr, index + 1, [...current, arr[index].values[i]]);
            }
        }

        combine(options, 0, []);

        const variantsAv = variants.map((v) => v.selectedOptions.map((o: any) => o.value).join(OPTION_SEPARATOR));
        const outOfStockVaraints = variants
            .filter((v) => v.availableForSale == false)
            .map((v) => v.selectedOptions.map((o: any) => o.value).join(OPTION_SEPARATOR));

        const missingVariants = result.filter((item: string) => !variantsAv.includes(item));

        return [...missingVariants, ...outOfStockVaraints];
    }

    const unavailable_combinations = notExistVariants(options);
    console._log("UNAVAILABLE COMBINATIONS: ", unavailable_combinations);

    const handleSwatchClick = (optionValue: string, optionName: string, optionIndex: number) => {
        const currentSelectedVariant = selected[productCardIndex];
        const updatedSelectedOptions = [...currentSelectedVariant.selectedOptions];

        updatedSelectedOptions[optionIndex] = { ...updatedSelectedOptions[optionIndex], value: optionValue };

        const selectedOptionsArray = updatedSelectedOptions.map((option) => option.value);
        // console._log({ selectedOptionsArray });

        const matchingVariant = findSelectedVariant(selectedOptionsArray, optionIndex);

        if (matchingVariant) {
            const updatedSelected = [...selected];
            updatedSelected[productCardIndex] = {
                ...matchingVariant,
                copyPrice: matchingVariant.price,
            };

            handleChange(updatedSelected);
        } else {
            console._log("Matching varint not found, means it doesnt exist.");
        }
    };

    const isSelected = (optionName: string, value: string) => {
        const selectedVariant = selected[productCardIndex];
        if (selectedVariant) {
            return selectedVariant.selectedOptions?.some(
                (option: any) => option.name === optionName && option.value === value,
            );
        }
        return false;
    };

    const findSelectedVariant = (selectedOptionsArray: string[], optionIndex?: number) => {
        let exactMatch: any = null;
        let nextMatch: any = null;

        for (const variant of variants) {
            const hasAllSelectedOptions = selectedOptionsArray.every(
                (selectedValue, i) => variant.selectedOptions[i].value === selectedValue,
            );
            if (hasAllSelectedOptions) {
                exactMatch = {
                    ...variant,
                    copyPrice: variant.price,
                };
            } else if (optionIndex !== undefined) {
                const hasAllSelectedOptions = selectedOptionsArray
                    .slice(0, optionIndex + 1)
                    .every((selectedValue, i) => variant.selectedOptions[i].value === selectedValue);
                if (hasAllSelectedOptions) {
                    nextMatch = {
                        ...variant,
                        copyPrice: variant.price,
                    };
                }
                // return next available variant
                console._log("Variant not found for options: ", selectedOptionsArray);
            }
        }
        return exactMatch || nextMatch;
    };

    const isCombinationUnavailable = (combination: string) => {
        return unavailable_combinations.includes(combination);
    };

    function isOptionAvailable(curCombArr: any[], index: number, value: string): boolean {
        let isAvailable = false;
        curCombArr[index] = value; // set the value for current option

        variants.forEach((variant) => {
            if (variant.availableForSale == false || isAvailable) return; // skip unavailable variants

            const variantOptions = variant.selectedOptions.map((o: any) => o.value);

            // every option up to current index should match

            if (variantOptions.slice(0, index + 1).every((val: string, idx: number) => val === curCombArr[idx]))
                isAvailable = true;
        });

        return isAvailable;
    }

    const generateCurrentCombination = () => {
        const selectedOptions = selected[productCardIndex]?.selectedOptions;
        return selectedOptions?.map((option: any) => option.value).join(OPTION_SEPARATOR) || "";
    };

    const renderSwatches = (option: any) => {
        // common helpers
        const currentCombination = `${generateCurrentCombination()}`;
        const curCombArr = currentCombination.split(OPTION_SEPARATOR);
        const optionIndex = options.findIndex((opt) => opt.name === option.name);
        const shopCheck =
            (userShopname === SPORTS_TOP_URL ||
                userShopname === MAYUR_TEST_STORE ||
                userShopname === "anurag-1010.myshopify.com") &&
            bundleConfig.bundle_type === BundleTypes.STANDARD &&
            bundleConfig.selected_template_standard !== AvailableStandardTemplates.HORIZONTAL_BASIC;
        const isSideLabel = shopCheck || bundleConfig?.variant_label_position === "beside";

        const generateCurrentCombinationForOption = (optionName: string): string => {
            const index = options.findIndex((opt) => opt.name === optionName); // get index
            return curCombArr[index] ?? ""; // return selected value from current combination
        };
        let swatches_select_color;
        if (isCart) {
            swatches_select_color = upsellDesign?.swatches_select_color || "#000000"; // for cart
        } else {
            swatches_select_color = bundlesDesign?.variant_selector_text_color || "#000000"; // for bundles
        }

        // DROPDOWN CASE
        const selectedValue = generateCurrentCombinationForOption(option.name); // helper fn for selected val
        // STEP 1: Generate dropdownOptions array from option.values
        const dropdownOptions = option.values.map((val: string) => ({
            value: val,
            isUnavailable: !isOptionAvailable(curCombArr, optionIndex, val),
        }));

        // STEP 2: Find selected option object from dropdownOptions
        const selectedOptionObj = dropdownOptions.find(
            (opt: { value: string; isUnavailable: boolean }) => opt.value === selectedValue,
        );

        return (
            <InspectorEditableBlock
                key={option.id}
                bundleType={bundleConfig?.bundle_type}
                settingKey="swatchesSelector"
            >
                <div
                    className={styles.variantContainer}
                    style={{
                        width:
                            bundleConfig?.use_compact_spacing || isSideLabel
                                ? "fit-content"
                                : isFullWidthSwatchTemplate
                                  ? selected?.length > 1
                                      ? "87%"
                                      : "100%"
                                  : undefined,
                        minWidth: bundleConfig?.use_compact_spacing || isSideLabel ? 0 : undefined,
                        flexGrow: bundleConfig?.bundleType === BundleTypes.FBT ? 1 : undefined,
                        flexDirection: isSideLabel ? "row" : undefined,
                        alignItems: isSideLabel ? "center" : undefined,
                        gap: isSideLabel ? "4px" : undefined,
                    }}
                >
                    {!hideLabel && (
                        <label
                            className={styles.selectLabel}
                            title={option.name}
                            style={{
                                color: bundlesDesign?.variant_selector_text_color,
                                fontSize: bundlesDesign?.variant_selector_text_size,
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                                wordBreak: isSideLabel ? "normal" : "break-word",
                                margin: 0,
                                ...(hideLabel && bundleConfig?.use_compact_spacing
                                    ? { height: 0, overflow: "hidden", visibility: "hidden" as const }
                                    : {}),
                            }}
                        >
                            {option.name}
                            {isSideLabel ? ":" : ""}
                        </label>
                    )}
                    {/* {option.values?.length > 1 && (
                        <select
                            value={selectedValue}
                            className={styles.select}
                            onChange={(e) => handleSwatchClick(e.target.value, option.name, optionIndex)} // same click handler
                            style={{
                                fontSize: bundlesDesign?.variant_selector_text_size,

                                // @ts-expect-error required
                                "--customColor": swatches_select_color ?? "#383838",
                                fontWeight: bundlesDesign?.variant_selector_text_style?.split(" ")[0] ?? "450",
                                fontStyle: bundlesDesign?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                                fontFamily:
                                    bundlesDesign?.bundle_widget_font_family === "Custom Store Font"
                                        ? "inherit"
                                        : bundlesDesign?.bundle_widget_font_family,
                            }}
                        >
                            {option.values.map((value: string) => {
                                const newComb = [...curCombArr]; // clone current combo

                                const isAvailable = isOptionAvailable(newComb, optionIndex, value); // check unavailable

                                return (
                                    <option key={value} value={value} disabled={!isAvailable}>
                                        {value}
                                    </option>
                                );
                            })}
                        </select>
                    )} */}
                    <CustomDropdown
                        selectedValue={selectedOptionObj}
                        // All dropdown option objects with isUnavailable status
                        options={dropdownOptions}
                        onSelect={(opt: any) => handleSwatchClick(opt.value, option.name, optionIndex)} // same click handler
                        // Optional: swatch styling or display configs
                        swatchType={null}
                        swatchSize={bundlesDesign?.swatchSize || 18}
                        swatchShape={bundlesDesign?.swatchShape || "rounded"}
                        // Theme/styling config
                        swatches_select_color={bundlesDesign?.variant_selector_text_color || "#383838"}
                        bundlesDesign={bundlesDesign}
                        standAlone={standAlone}
                        bundleConfig={bundleConfig}
                    />
                </div>
            </InspectorEditableBlock>
        );

        return null; // fallback
    };

    const isFullWidthSwatchTemplate =
        bundleConfig?.selected_template_standard === AvailableStandardTemplates.HORIZONTAL_BASIC ||
        bundleConfig?.selected_template_fbt === AvailableFBTTemplates.HORIZONTAL ||
        bundleConfig?.selected_template_bxgy === AvailableBXGYTemplates.HORIZONTAL_BASIC ||
        bundleConfig?.bundle_type === BundleTypes.BUNDLE_BUILDER ||
        bundleConfig?.bundle_type === BundleTypes.BUNDLE_BUILDER_CTA ||
        bundleConfig?.bundle_type === BundleTypes.BB_PLACEHOLDER;

    return (
        <div
            className={styles.optionsOuterContainer}
            style={{
                alignItems:
                    userShopname === SPORTS_TOP_URL ||
                    userShopname === MAYUR_TEST_STORE ||
                    userShopname === "anurag-1010.myshopify.com"
                        ? "center"
                        : undefined,
            }}
        >
            {!hideSerialNumber &&
                selected?.length > 1 &&
                (bundleConfig?.bundle_type == BundleTypes.MIX_MATCH ||
                    bundleConfig?.bundle_type == BundleTypes.MIX_MATCH_SECTIONAL ||
                    bundleConfig?.bundle_type == BundleTypes.VOLUME_DISCOUNT ||
                    bundleConfig?.bundle_type == BundleTypes.STANDARD) && (
                    <div
                        style={{
                            color: bundlesDesign?.variant_selector_text_color ?? "#383838",
                            paddingTop: bundleConfig?.variant_label_position === "beside" ? "6px" : undefined,
                            fontSize: bundlesDesign?.variant_selector_text_size - 1,
                            minWidth: bundlesDesign?.variant_selector_text_size - 2,
                        }}
                        className={styles.serialNumberContainer}
                    >
                        <span>{productCardIndex + 1 + "."}</span>
                    </div>
                )}
            <div
                className={styles.VariantOptionContainer}
                style={{
                    flexDirection:
                        userShopname === SPORTS_TOP_URL ||
                        userShopname === MAYUR_TEST_STORE ||
                        userShopname === "anura-1010.myshopify.com "
                            ? "column"
                            : undefined,
                }}
            >
                {options.map((option) => renderSwatches(option))}
            </div>
        </div>
    );
};
const BundlePreviewWrapper = ({
    bundleConfig,
    children,
    standAlone,
    transformedVariants,
    mnm_part_of,
    unavailableDiscountSelected = {},
    currency,
    money_format,
    totalPrice = null,
    discountedPrice = null,
    compareAtPriceTotal,
    targetForm,
    otherLoading = false,
    isMainProductOutOfStock = false,
    overrideMobile = null,
    hideBundleTitle = false,
}: {
    children: ReactNode;
    standAlone?: boolean;
    unavailableDiscountSelected?: {
        [key: number]: number[];
    };
    bundleConfig:
        | StandardConfigInterface
        | VolumeConfigInterface
        | MixMatchConfigInterface
        | BxgyConfigInterface
        | FBTConfigInterface
        | ProductAddonsConfigInterface
        | PlaceholderConfigInterface
        | ProductAddonsPopupConfigInterface;
    transformedVariants?: any;
    mnm_part_of?: string;
    currency: string;
    money_format: string;
    totalPrice?: number | null;
    discountedPrice?: number | null;
    activeDiscountIndex?: number;
    compareAtPriceTotal?: number;
    targetForm?: any;
    otherLoading?: boolean;
    isMainProductOutOfStock?: boolean;
    overrideMobile?: boolean | null;
    hideBundleTitle?: boolean;
}) => {
    const [loading, setLoading] = useState(false);
    const [finalPrice, setFinalPrice] = useState(0);
    const appName = config.appName;
    const { isMobile: _isMobile } = useIsMobile();
    const isMobile = overrideMobile != null ? overrideMobile : _isMobile;
    const bundleWrapperRef = useRef<HTMLDivElement>(null);
    const [quantity, setQuantity] = useState(1);

    const bundleWrapperWidth = bundleWrapperRef.current?.offsetWidth || -1;
    const userShopname = standAlone ? window.kefi_bundles.shop : shopify.config.shop || "";
    const alwaysShowBundleTitle = [
        "mein-schoener-garten-shop.myshopify.com",
        "goodproductsstore-2.myshopify.com",
    ].includes(userShopname);

    const isFBT =
        bundleConfig?.bundle_type == BundleTypes.FBT ||
        (bundleConfig?.bundle_type == BundleTypes.BXGY &&
            // @ts-expect-error hack
            bundleConfig?.selected_template_bxgy == AvailableBXGYTemplates.HORIZONTAL_BASIC);
    const isProductAddonPopup = bundleConfig?.bundle_type == BundleTypes.PRODUCT_ADDONS_POPUP;
    const isStandardBundle = bundleConfig?.bundle_type == BundleTypes.STANDARD;

    useEffect(() => {
        // @ts-expect-error hack
        if (standAlone && bundleConfig?.form_id && bundleConfig?.shop) {
            updateBundleStats({
                id: bundleConfig?.form_id,
                key: "views",
                // @ts-expect-error hack
                shop: bundleConfig?.shop,
                appName: appName,
                view_type: 1,
            });

            if (bundleConfig?.bundle_type === BundleTypes.VOLUME_DISCOUNT) {
                trackAbVisitorEvent(bundleConfig as VolumeConfigInterface, "view", 1, appName);
            }
        }
    }, [bundleConfig?.form_id, standAlone]);

    useEffect(() => {
        if (totalPrice != null) {
            switch (bundleConfig?.bundle_type) {
                case BundleTypes.MIX_MATCH:
                    // @ts-expect-error hack
                    // eslint-disable-next-line no-case-declarations
                    let newDiscountValue = bundleConfig?.discount_value;

                    // @ts-expect-error hack
                    if (bundleConfig?.discount_type === "percentage" && bundleConfig?.max_allowed_discount !== null) {
                        const totalAmount = totalPrice;

                        // @ts-expect-error hack
                        const maxAllowedDiscount = bundleConfig?.max_allowed_discount;

                        const currentDiscountAmount = (newDiscountValue / 100) * totalAmount;

                        if (currentDiscountAmount > maxAllowedDiscount) {
                            const adjustedPercentage = (maxAllowedDiscount / totalAmount) * 100;
                            newDiscountValue = adjustedPercentage;
                        }
                    }

                    setFinalPrice(
                        getFinalPrice(
                            // @ts-expect-error hack
                            bundleConfig?.discount_type,
                            newDiscountValue || 0,
                            totalPrice,
                        ),
                    );
                    break;

                case BundleTypes.MIX_MATCH_SECTIONAL:
                    // @ts-expect-error hack
                    // eslint-disable-next-line no-case-declarations
                    let newDiscountValueSectional = bundleConfig?.discount_value;

                    // @ts-expect-error hack
                    if (bundleConfig?.discount_type === "percentage" && bundleConfig?.max_allowed_discount !== null) {
                        const totalAmount = totalPrice;

                        // @ts-expect-error hack
                        const maxAllowedDiscount = bundleConfig?.max_allowed_discount;

                        const currentDiscountAmount = (newDiscountValueSectional / 100) * totalAmount;

                        if (currentDiscountAmount > maxAllowedDiscount) {
                            const adjustedPercentage = (maxAllowedDiscount / totalAmount) * 100;
                            newDiscountValueSectional = adjustedPercentage;
                        }
                    }

                    setFinalPrice(
                        getFinalPrice(
                            // @ts-expect-error hack
                            bundleConfig?.discount_type,
                            newDiscountValueSectional || 0,
                            totalPrice,
                        ),
                    );
                    break;
                case BundleTypes.FBT:
                    setFinalPrice(
                        getFinalPrice(
                            // @ts-expect-error hack
                            bundleConfig?.discount_type,
                            // @ts-expect-error hack
                            bundleConfig?.discount_value || 0,
                            totalPrice,
                        ),
                    );
                    break;
                case BundleTypes.PRODUCT_ADDONS:
                    setFinalPrice(
                        getFinalPrice(
                            // @ts-expect-error hack
                            bundleConfig?.discount_type,
                            // @ts-expect-error hack
                            bundleConfig?.discount_value || 0,
                            totalPrice,
                        ),
                    );
                    break;
                case BundleTypes.PRODUCT_ADDONS_POPUP:
                    setFinalPrice(
                        getFinalPrice(
                            // @ts-expect-error hack
                            bundleConfig?.discount_type,
                            // @ts-expect-error hack
                            bundleConfig?.discount_value || 0,
                            totalPrice,
                        ),
                    );
                    break;
                case BundleTypes?.STANDARD:
                case BundleTypes.BB_PLACEHOLDER:
                    setFinalPrice(
                        getFinalPrice(
                            // @ts-expect-error hack
                            bundleConfig?.discount_type,
                            // @ts-expect-error hack
                            bundleConfig?.discount_value || 0,
                            totalPrice,
                        ),
                    );
                    break;

                case BundleTypes.VOLUME_DISCOUNT:
                    setFinalPrice(totalPrice);
                    break;

                case BundleTypes.BUY_N:
                    setFinalPrice(discountedPrice || 0);
                    break;

                default:
                    setFinalPrice(
                        getFinalPrice(
                            // @ts-expect-error hack
                            bundleConfig?.discount_type,
                            // @ts-expect-error hack
                            bundleConfig?.discount_value || 0,
                            discountedPrice || 0,
                            totalPrice,
                        ),
                    );
            }
        }
    }, [
        discountedPrice,
        totalPrice,
        bundleConfig.bundle_type,
        // @ts-expect-error hack
        bundleConfig?.discount_type,
        // @ts-expect-error hack
        bundleConfig?.discount_value,
        // @ts-expect-error hack
        bundleConfig?.discount_options,
        // @ts-expect-error hack
        bundleConfig?.max_allowed_discount,
    ]);

    const [showCheckoutModal, setShowCheckoutModal] = useState(false);

    const addToCart = async () => {
        setLoading(true);
        try {
            updateBundleStats({
                id: bundleConfig?.form_id,
                key: "clicks",
                // @ts-expect-error hack
                shop: bundleConfig?.shop,
                appName: appName,
                view_type: 1,
            });

            if (bundleConfig?.bundle_type === BundleTypes.VOLUME_DISCOUNT) {
                trackAbVisitorEvent(bundleConfig as VolumeConfigInterface, "click", 1, appName);
            }
            bundleConfig?.form_id;
            bundleConfig?.bundle_type;

            document.dispatchEvent(new CustomEvent(ADD_TO_CART_CLICKED, { detail: {} }));

            if (bundleConfig?.bundle_type === BundleTypes.BB_PLACEHOLDER) {
                if (bundleConfig?.hasStepErrorsLeft) {
                    setLoading(false);
                    return;
                }
                const items: any[] = [];
                const freeItems: any[] = [];
                const allowedShopsLahParis = ["lah-paris.myshopify.com", ADITYA_STORE, MAYUR_TEST_STORE];

                bundleConfig.products?.forEach((p: any) => {
                    p.selectedVariants.forEach((selected: any) => {
                        if (selected?.freeGift) {
                            freeItems.push({
                                id: `${selected.id.split("/")?.splice(-1)[0]}`,
                                quantity: selected?.qty ? +selected.qty : 1,
                                fields: [],
                            });
                        } else {
                            let sellingPlanName = allowedShopsLahParis.includes(userShopname)
                                ? selected?.subscriptions?.[0]?.name
                                : undefined;
                            // only for lah-paris store we are sending selling plan name, if that products quanity is 0 or less. i.e out of stock.
                            const availableQty =
                                selected?.quantityAvailable && selected?.quantityAvailable > 0 ? selected?.qty : 0;
                            if (availableQty > 0) {
                                sellingPlanName = undefined;
                            }

                            items.push({
                                id: `${selected.id.split("/")?.splice(-1)[0]}`,
                                quantity: selected?.qty ? +selected.qty : 1,
                                ...(sellingPlanName ? { sellingPlanName } : {}),
                                fields: [],
                            });
                        }
                    });
                });

                const cartToken = await cartWatcher.cart.token;
                if (items.length == 0) {
                    setLoading(false);
                    return;
                }

                const mergedItems = mergeById(items);

                await handleBundleCheckout({
                    items: mergedItems,
                    freeItems,
                    formId: bundleConfig?.form_id || "",
                    token: cartToken,
                    redirectOptions: (bundleConfig as PlaceholderConfigInterface)?.redirect_options,
                    showPopupOnCartRedirect: (bundleConfig as PlaceholderConfigInterface)?.show_popup_on_cart_redirect,
                    setShowCheckoutModal,
                    setLoadingState: setLoading,
                    bundleType: BundleTypes.BB_PLACEHOLDER,
                });
                return;
            }

            if (
                "bundle_as_product" in bundleConfig &&
                bundleConfig.isProductPageVisible &&
                !isThirdPartyCheckout() &&
                bundleConfig?.bundle_type !== BundleTypes.MIX_MATCH &&
                bundleConfig?.bundle_type !== BundleTypes.MIX_MATCH_SECTIONAL
            ) {
                if (userShopname === SPORTS_TOP_URL || userShopname === MAYUR_TEST_STORE) {
                    const { isValid, minAvailableQty } = checkBundleStockAvailability(
                        bundleConfig?.products,
                        quantity || 1,
                        bundleConfig.form_id || "",
                    );

                    if (!isValid) {
                        if (minAvailableQty !== undefined) {
                            setQuantity(minAvailableQty);
                        }
                        setLoading(false);
                        return;
                    }
                }

                await addBundleToCart(
                    [
                        {
                            selectedVariants: [
                                { id: getProductAsBundleVariantId(bundleConfig), quantity: quantity || 1 },
                            ],
                        },
                        ...(bundleConfig.free_gifts || []),
                    ],
                    { _options: JSON.stringify(transformedVariants) },
                    bundleConfig.form_id || "",
                    !!bundleConfig?.general_settings?.redirect_to_checkout,
                    bundleConfig?.bundle_type,
                );
            } else if (
                isFBT &&
                // @ts-expect-error hack
                bundleConfig?.fbt_product_selection == "all"
            ) {
                await addBundleToCart(
                    bundleConfig.products,
                    {},
                    bundleConfig.form_id || "",
                    !!bundleConfig?.general_settings?.redirect_to_checkout,
                    bundleConfig?.bundle_type,
                );
            } else if (bundleConfig?.bundle_type == BundleTypes.BXGY) {
                await addBundleToCart(
                    bundleConfig.products
                        .concat(bundleConfig?.discounted_products)
                        .concat(bundleConfig?.free_gifts || []),
                    {},
                    bundleConfig.form_id || "",
                    !!bundleConfig?.general_settings?.redirect_to_checkout,
                    bundleConfig?.bundle_type,
                );
            } else if (bundleConfig?.bundle_type == BundleTypes.PRODUCT_ADDONS) {
                if (userShopname === SPORTS_TOP_URL || userShopname === MAYUR_TEST_STORE) {
                    const productsWithQuantity = bundleConfig.products.map((product: any, index: number) => ({
                        ...product,
                        selectedVariants: product.selectedVariants?.map((variant: any) => ({
                            ...variant,
                            quantity: index === 0 ? (variant.quantity || 1) * quantity : variant.quantity || 1,
                        })),
                    }));

                    await addBundleToCart(
                        // @ts-expect-error hack
                        productsWithQuantity.concat(bundleConfig?.free_gifts || []),
                        {},
                        bundleConfig.form_id || "",
                        !!bundleConfig?.general_settings?.redirect_to_checkout,
                        bundleConfig?.bundle_type,
                    );
                } else {
                    await addBundleToCart(
                        // @ts-expect-error hack
                        bundleConfig.products.concat(bundleConfig?.free_gifts || []),
                        {},
                        bundleConfig.form_id || "",
                        !!bundleConfig?.general_settings?.redirect_to_checkout,
                        bundleConfig?.bundle_type,
                    );
                }
            } else if (bundleConfig?.bundle_type == BundleTypes.PRODUCT_ADDONS_POPUP) {
                await addBundleToCart(
                    bundleConfig.products,
                    {},
                    bundleConfig.form_id || "",
                    !!bundleConfig?.general_settings?.redirect_to_checkout,
                    bundleConfig?.bundle_type,
                );
            } else if (bundleConfig?.bundle_type == BundleTypes.MIX_MATCH_SECTIONAL) {
                await addBundleToCart(
                    // @ts-expect-error hack
                    bundleConfig.products.concat(bundleConfig?.free_gifts || []),
                    {},
                    bundleConfig.form_id || "",
                    !!bundleConfig?.general_settings?.redirect_to_checkout,
                    bundleConfig?.bundle_type,
                    // @ts-expect-error required
                    bundleConfig?.mnmSectionalMessage,
                );
            } else if (bundleConfig?.bundle_type == BundleTypes.MIX_MATCH) {
                await addBundleToCart(
                    // @ts-expect-error hack
                    bundleConfig.products.concat(bundleConfig?.free_gifts || []),
                    { mnm_part_of: mnm_part_of },
                    bundleConfig.form_id || "",
                    !!bundleConfig?.general_settings?.redirect_to_checkout,
                    bundleConfig?.bundle_type,
                );
            } else if (bundleConfig?.bundle_type == BundleTypes.VOLUME_DISCOUNT) {
                await addBundleToCart(
                    bundleConfig.products
                        .concat((bundleConfig as VolumeConfigInterface)?.free_gifts || [])
                        .concat((bundleConfig as VolumeConfigInterface)?.bundle_products || [])
                        .concat((bundleConfig as VolumeConfigInterface)?.upsell_products || []),
                    {},
                    bundleConfig.form_id || "",
                    !!bundleConfig?.general_settings?.redirect_to_checkout,
                    bundleConfig?.bundle_type,
                );
            } else {
                await addBundleToCart(
                    // @ts-expect-error hack
                    bundleConfig.products.concat(bundleConfig?.free_gifts || []),
                    {},
                    bundleConfig.form_id || "",
                    !!bundleConfig?.general_settings?.redirect_to_checkout,
                    bundleConfig?.bundle_type,
                );
            }
        } finally {
            setLoading(false);
        }
    };

    const productPageVisible = (bundleConfig: any) => {
        return (
            (bundleConfig.bundle_type === "standard" || bundleConfig.bundle_type === "bxgy") &&
            "isProductPageVisible" in bundleConfig &&
            bundleConfig.isProductPageVisible
        );
    };

    const { alpha } = hexToHsba(bundleConfig?.bundles_design?.bundle_widget_bg);

    if (
        window.kefi_bundles.shop === "nuphy-store.myshopify.com" ||
        window.kefi_bundles.shop === "jass-solution.myshopify.com"
    )
        bundleConfig.max_width = "15000";

    const custom_css = bundleConfig?.bundles_settings?.custom_css || "";
    const custom_js = bundleConfig?.bundles_settings?.custom_js || "";

    useEffect(() => {
        const formId = bundleConfig.form_id || "";

        if (custom_css) {
            injectScopedCSS(custom_css, formId);
        }

        if (custom_js) {
            executeScopedJS(custom_js, formId);
        }

        return () => {
            document.querySelector(`style[data-form-id="${formId}"]`)?.remove();
        };
    }, [bundleConfig.form_id]);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: standAlone ? bundleConfig?.general_settings?.bundle_alignment : "center",
                width: "100%",
            }}
            id={isFBT ? "" : "kefi_" + bundleConfig.form_id}
            data-form-id={bundleConfig.form_id}
        >
            <InspectorEditableBlock
                bundleType={bundleConfig?.bundle_type}
                settingKey="bundlePreviewWrapper"
                wrapWithDiv={true}
            >
                {IS_METAL_BIRD_SHOP &&
                    bundleConfig.bundle_type == BundleTypes.MIX_MATCH &&
                    MetalBirdBundlePreviewStyles}

                {showCheckoutModal && (
                    <CheckoutModal
                        showCheckoutModal={showCheckoutModal}
                        bundleConfig={bundleConfig}
                        onClose={() => {
                            setShowCheckoutModal(false);
                        }}
                    />
                )}

                <div
                    ref={bundleWrapperRef}
                    className={`${styles.bundlePreviewWrapper}   ${
                        // @ts-expect-error required
                        isDesktopUIForMixMatch(bundleWrapperWidth, bundleConfig.bundle_type) ? "kefiMMDesktop" : ""
                    }`}
                    style={{
                        borderRadius: bundleConfig?.bundles_design?.border_radius,
                        background: isProductAddonPopup
                            ? "transparent"
                            : isStandardBundle
                              ? bundleConfig?.bundles_design?.product_background_color
                              : bundleConfig?.bundles_design?.bundle_widget_bg,
                        fontFamily:
                            bundleConfig?.bundles_design?.bundle_widget_font_family == "Custom Store Font"
                                ? "inherit"
                                : bundleConfig?.bundles_design?.bundle_widget_font_family,
                        marginTop:
                            bundleConfig?.bundle_type == BundleTypes.PRODUCT_ADDONS_POPUP ||
                            bundleConfig?.bundle_type == BundleTypes.PRODUCT_ADDONS
                                ? 0
                                : standAlone
                                  ? bundleConfig?.general_settings?.override_margin_top
                                      ? bundleConfig?.general_settings?.margin_top
                                      : 20
                                  : 0,
                        paddingBottom: isProductAddonPopup ? 0 : 0,
                        maxWidth: isFBT
                            ? // @ts-expect-error required
                              bundleConfig?.selected_template_fbt === AvailableFBTTemplates.VERTICAL
                                ? (bundleConfig?.general_settings?.override_max_width
                                      ? bundleConfig?.general_settings?.max_width
                                      : bundleConfig?.max_width) !== undefined
                                    ? `${
                                          bundleConfig?.general_settings?.override_max_width
                                              ? bundleConfig?.general_settings?.max_width
                                              : bundleConfig?.max_width
                                      }px`
                                    : undefined
                                : undefined
                            : (bundleConfig?.general_settings?.override_max_width
                                    ? bundleConfig?.general_settings?.max_width
                                    : bundleConfig?.max_width) !== undefined
                              ? `${
                                    bundleConfig?.general_settings?.override_max_width
                                        ? bundleConfig?.general_settings?.max_width
                                        : bundleConfig?.max_width
                                }px`
                              : undefined,
                        border:
                            bundleConfig?.bundle_type == BundleTypes.STANDARD
                                ? //  @ts-expect-error hack
                                  `${bundleConfig?.bundles_design?.bundle_border_width}px solid ${bundleConfig?.bundles_design?.bundle_border_color}`
                                : bundleConfig?.bundle_type == BundleTypes.MIX_MATCH ||
                                    bundleConfig?.bundle_type == BundleTypes.MIX_MATCH_SECTIONAL
                                  ? "1px solid #dadada"
                                  : "none",
                        minWidth: 260,
                        marginBottom:
                            (!standAlone && bundleConfig?.bundles_design?.default_cta) ||
                            bundleConfig?.bundle_type == BundleTypes.PRODUCT_ADDONS ||
                            isFBT ||
                            isProductAddonPopup
                                ? 0
                                : 10,
                        width: bundleConfig.bundle_type === "product_add_on" ? "98%" : "100%",
                        ...(isFBT && {
                            display: "flex",
                            padding: alpha > 0 ? 15 : 0,
                            minWidth: "unset",
                        }),
                        ...(isFBT &&
                            standAlone &&
                            !bundleConfig?.general_settings?.override_margin_top && {
                                marginTop: 10,
                            }),
                        ...(bundleConfig.bundle_type === BundleTypes.BXGY &&
                            bundleConfig?.selected_template_bxgy === AvailableBXGYTemplates.HORIZONTAL_BASIC && {
                                padding: 0,
                            }),

                        marginLeft: !standAlone ? 0 : undefined,
                        marginRight: !standAlone ? 0 : undefined,
                        overflow: "hidden",
                        paddingBlock: bundleConfig?.bundle_type == BundleTypes.PRODUCT_ADDONS ? 0 : 10,
                    }}
                    id="bundlePreviewWrapper"
                >
                    <div
                        style={{
                            paddingInline: isFBT
                                ? 0
                                : bundleConfig?.bundle_type == "mixmatch" ||
                                    bundleConfig?.bundle_type == BundleTypes.MIX_MATCH_SECTIONAL
                                  ? "10px"
                                  : alpha == 0
                                    ? "0px"
                                    : "10px",
                        }}
                        className={styles.prevWrapperChild}
                    >
                        {bundleConfig.bundle_type === BundleTypes.PRODUCT_ADDONS &&
                            (bundleConfig as ProductAddonsConfigInterface)?.is_cta_above == true && (
                                <div style={{ marginBottom: "15px" }}>
                                    <BundlePreviewFooter
                                        isFBT={isFBT}
                                        standAlone={!!standAlone}
                                        totalPrice={totalPrice as unknown as number}
                                        finalPrice={finalPrice}
                                        discountedPrice={discountedPrice as unknown as number}
                                        targetForm={targetForm}
                                        compareAtPriceTotal={compareAtPriceTotal}
                                        money_format={money_format}
                                        currency={currency}
                                        bundleConfig={bundleConfig}
                                        loading={loading}
                                        unavailableDiscountSelected={unavailableDiscountSelected}
                                        addToCart={addToCart}
                                        productPageVisible={productPageVisible}
                                        otherLoading={otherLoading}
                                        isMainProductOutOfStock={isMainProductOutOfStock}
                                        isMobile={isMobile}
                                        bundleWrapperWidth={bundleWrapperWidth}
                                        quantity={quantity}
                                        setQuantity={setQuantity}
                                    />
                                </div>
                            )}
                        {!hideBundleTitle && (
                            <InspectorEditableBlock settingKey="bundleTitle" bundleType={bundleConfig?.bundle_type}>
                                <div
                                    style={{
                                        textAlign: isFBT || isProductAddonPopup ? "left" : "center",
                                        // whiteSpace: "nowrap",
                                        wordBreak: "break-word",
                                        paddingBottom: "6px",
                                        // overflow: "hidden",
                                        // textOverflow: "ellipsis",
                                        paddingRight: "10px",
                                        paddingLeft: isFBT || isProductAddonPopup ? 0 : "10px",
                                        fontSize:
                                            bundleConfig?.bundles_design?.bundle_title_size <= 50
                                                ? bundleConfig?.bundles_design?.bundle_title_size
                                                : 50,
                                        color: bundleConfig?.bundles_design?.bundle_title_color,
                                        fontWeight: bundleConfig?.bundles_design?.bundle_title_style?.split(" ")[0],
                                        fontStyle: bundleConfig?.bundles_design?.bundle_title_style?.split(" ")[1],
                                        lineHeight: "normal",
                                        ...(bundleConfig?.bundle_type === BundleTypes.VOLUME_DISCOUNT && {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }),
                                    }}
                                    className={styles.bundleTitle}
                                >
                                    {(bundleConfig as VolumeConfigInterface)?.show_line_around_title && (
                                        <span
                                            style={{
                                                flex: 1,
                                                height: "2px",
                                                backgroundColor: (bundleConfig as VolumeConfigInterface)?.bundles_design
                                                    ?.show_line_around_title_color,
                                                marginRight: "10px",
                                            }}
                                        />
                                    )}
                                    {window.isKefiAdmin || alwaysShowBundleTitle
                                        ? bundleConfig.title
                                        : (bundleConfig?.bundle_type == BundleTypes.STANDARD ||
                                                bundleConfig?.bundle_type == BundleTypes.BB_PLACEHOLDER) &&
                                            "product_bundle_id" in bundleConfig &&
                                            bundleConfig?.product_bundle_id === window?.kefi_bundles?.product?.id &&
                                            (bundleConfig as any).user_id > 1628
                                          ? ""
                                          : bundleConfig.title}
                                    {(bundleConfig as VolumeConfigInterface)?.show_line_around_title && (
                                        <span
                                            style={{
                                                flex: 1,
                                                height: "2px",
                                                backgroundColor: (bundleConfig as VolumeConfigInterface)?.bundles_design
                                                    ?.show_line_around_title_color,
                                                marginLeft: "10px",
                                            }}
                                        />
                                    )}
                                </div>
                            </InspectorEditableBlock>
                        )}
                        <div
                            className={`${styles.bundlePreviewChildrenWrapper} ${isFBT ? styles.bundlePreviewFBTChildren : ""}`}
                            style={{
                                alignItems:
                                    bundleConfig.bundle_type == "bxgy"
                                        ? bundleConfig?.selected_template_bxgy ===
                                          AvailableBXGYTemplates.HORIZONTAL_BASIC
                                            ? "stretch"
                                            : "center"
                                        : "flex-start",
                                ...(isFBT && {
                                    marginTop:
                                        bundleConfig?.products.length || bundleConfig?.offered_products?.length
                                            ? 0
                                            : 40,
                                    flexWrap: isMobile ? "wrap" : "unset",
                                }),
                                ...(isFBT &&
                                    standAlone &&
                                    "selected_template_fbt" in bundleConfig &&
                                    bundleConfig?.selected_template_fbt === AvailableFBTTemplates.VERTICAL && {
                                        flexDirection: "column",
                                    }),

                                ...(bundleConfig.bundle_type === BundleTypes.BXGY &&
                                    bundleConfig?.selected_template_bxgy ===
                                        AvailableBXGYTemplates.HORIZONTAL_BASIC && {
                                        flexDirection: "column",
                                        overflow: "visible",
                                    }),
                            }}
                        >
                            {bundleConfig.bundle_type === BundleTypes.BXGY &&
                            bundleConfig?.selected_template_bxgy === AvailableBXGYTemplates.HORIZONTAL_BASIC ? (
                                <div
                                    className={styles.bundlePreviewFBTChildren}
                                    style={{
                                        display: "grid",
                                        gridAutoColumns: "minmax(140px, 1fr)",
                                        gridAutoFlow: "column",
                                        gap: "20px",
                                        overflowX: "auto",
                                    }}
                                >
                                    {children}
                                </div>
                            ) : (
                                children
                            )}
                            {/* Show for standard if bundle_as_product is null, always show for others */}
                            {/* {bundleConfig?.is_cta_above !== true} */}
                            {(bundleConfig.bundle_type !== BundleTypes.PRODUCT_ADDONS ||
                                (bundleConfig as ProductAddonsConfigInterface)?.is_cta_above == false) && (
                                <BundlePreviewFooter
                                    isFBT={isFBT}
                                    standAlone={!!standAlone}
                                    totalPrice={totalPrice as unknown as number}
                                    finalPrice={finalPrice}
                                    discountedPrice={discountedPrice as unknown as number}
                                    targetForm={targetForm}
                                    compareAtPriceTotal={compareAtPriceTotal}
                                    money_format={money_format}
                                    currency={currency}
                                    bundleConfig={bundleConfig}
                                    loading={loading}
                                    unavailableDiscountSelected={unavailableDiscountSelected}
                                    addToCart={addToCart}
                                    productPageVisible={productPageVisible}
                                    otherLoading={otherLoading}
                                    isMainProductOutOfStock={isMainProductOutOfStock}
                                    isMobile={isMobile}
                                    bundleWrapperWidth={bundleWrapperWidth}
                                    quantity={quantity}
                                    setQuantity={setQuantity}
                                />
                            )}
                        </div>
                    </div>
                    {!isFBT && <PoweredByKefiBranding bundleConfig={bundleConfig} />}
                </div>
            </InspectorEditableBlock>
        </div>
    );
};

export default BundlePreviewWrapper;
